// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-12T19:38:12.657Z
// Property: The Deryn (ID: 6767906449167334)
// Collections: 26 amenities, 8 floorplans (live), 28 photos, 43 POIs, 5 reviews, 10 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162258",
  "multihub_property_id": "6767906449167334",
  "property_external_id": "100160117",
  "property_zillow_url": "https://www.zillow.com/apartments/gainesville-ga/the-deryn/5XhtvR/",
  "property_apartments_url": "https://www.apartments.com/the-deryn-gainesville-ga/fb30lft/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Deryn/data=!4m2!3m1!1s0x0:0xce425ec7922a4214?sa=X&ved=1t:2428&hl=en&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": "55472919606",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-deryn",
  "property_name": "The Deryn",
  "property_website_url": "https://www.liveatthederyn.com/",
  "property_domain": "https://www.liveatthederyn.com/",
  "property_address": "2745 Campus Pointe Cir",
  "property_full_address": "2745 Campus Pointe Cir, Gainesville, GA 30504",
  "property_address_1": "2745 Campus Pointe Cir",
  "property_address_2": null,
  "property_address_city": "Gainesville",
  "property_address_state": "GA",
  "property_address_zip_full": null,
  "property_address_zip": "30504",
  "property_address_country": "US",
  "property_address_county": "Hall County",
  "property_neighborhood_address": "Gainesville",
  "property_address_latitude": "34.2423275",
  "property_address_longitude": "-83.8576611",
  "property_email": "100160117-69694-109960-102052@guestcardlead.com",
  "property_phone": "4707193785",
  "property_call_tracking_phone": "4707193785",
  "property_company_name": "Axia Residential (ARC Living)",
  "property_company_url": "https://www.axiares.com/",
  "agency_contacts": null,
  "property_type": "Apartment",
  "property_short_description": "Welcome to The Deryn, where comfort meets convenience in Gainesville, GA. Choose from spacious one and three-bedroom layouts, perfect for any lifestyle. Enjoy exceptional amenities, including a vibrant poolside grilling area, a cutting-edge fitness center, and serene fire pits. Your ideal home awaits—browse our availability or schedule a tour today!",
  "property_long_description": "Welcome to The Deryn, the ultimate apartment community in Gainesville, GA, offering an exceptional blend of comfort and convenience just half a mile from the UNG campus. Choose from our thoughtfully designed floor plans, including spacious one-bedroom and three-bedroom apartments, tailored to fit your lifestyle.\n\nAt The Deryn, you'll enjoy a wealth of amenities that redefine modern living. Dive into relaxation at our sparkling swimming pool or host a delightful gathering with friends at our poolside grilling area. For fitness enthusiasts, our state-of-the-art fitness center, equipped with free weights, will help you maintain an active lifestyle. Unwind in the evening by the fire pits or take advantage of our outdoor grills for a perfect cookout experience.\n\nStay connected with high-speed internet and take advantage of our community study and business center, ideal for students and professionals alike. With on-site maintenance and management, package receiving, and valet trash service, your daily life is made easier.\n\nOur pet-friendly policy and furnished apartment options cater to all lifestyles, ensuring that everyone feels at home with us. Each unit is equipped with modern appliances including a refrigerator, dishwasher, microwave, and a full-sized washer and dryer, enhancing your everyday convenience. \n\nExperience carefree living with individual leases and the flexibility of short-term leases available for added convenience. \n\nFind your new home today at The Deryn—browse our availability or schedule a tour to visit our vibrant community! Your next chapter awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-55c8-708c-9f2d-fcb39ccc9c08.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and grills at an apartment complex.",
    "public_id": "019d54f3-55c8-708c-9f2d-fcb39ccc9c08",
    "storage_key": "property/6767906449167334/019d54f3-55c8-708c-9f2d-fcb39ccc9c08.webp",
    "width": 1900,
    "height": 895
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "304",
  "property_year_built": "2003",
  "property_year_renovated": null,
  "property_walk_score": "20",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "84.53947368421053",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Security Deposit (Refundable)\n$200.00",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Please call our Leasing Office for complete Pet Policy information.",
  "property_pet_policy_description": "Cats and dogs allowed. One-time pet fee per pet: $500–$1,000. Pet eligibility varies by apartment type. Rent is $35 per pet. Select residences, including our co-living homes, allow one (1) pet per private room with management approval.",
  "property_petpolicy_info": "\nPet Policy\nPet Types: Cats & Dogs\n\nBreed Restrictions Apply\n\nPet Fees\nFee: $500\nRent: $35.00",
  "property_online_leasing_url": "https://thederynaxia.prospectportal.com/Gainesville/The Deryn",
  "property_resident_portal_url": "https://thederynaxia.residentportal.com/auth",
  "property_apply_now_url": "https://thederynaxia.prospectportal.com/Apartments/module/application_authentication/popup/false/kill_session/1/property/100160117/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-477d-72cf-8759-88a68bf2659f.webp",
  "property_primary_logo_media": {
    "alt_text": "The Derlyn logo",
    "public_id": "019d54f3-477d-72cf-8759-88a68bf2659f",
    "storage_key": "property/6767906449167334/019d54f3-477d-72cf-8759-88a68bf2659f.webp",
    "width": 103,
    "height": 100
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d744a-7187-762d-abbd-bd84dfe6e50e.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Deryn property logo.",
    "public_id": "019d744a-7187-762d-abbd-bd84dfe6e50e",
    "storage_key": "property/6767906449167334/019d744a-7187-762d-abbd-bd84dfe6e50e.webp",
    "width": 1405,
    "height": 449
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019ddf84-473f-722e-85c3-eab373e682a2.webp",
  "property_fav_icon_media": {
    "alt_text": "Blue circle icon",
    "public_id": "019ddf84-473f-722e-85c3-eab373e682a2",
    "storage_key": "property/6767906449167334/019ddf84-473f-722e-85c3-eab373e682a2.webp",
    "width": 48,
    "height": 48
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d744a-f059-7069-a52d-9d7fdfb8964e.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Deryn logo with a stylized D inside a circle.",
    "public_id": "019d744a-f059-7069-a52d-9d7fdfb8964e",
    "storage_key": "property/6767906449167334/019d744a-f059-7069-a52d-9d7fdfb8964e.webp",
    "width": 500,
    "height": 500
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d744a-efb5-701c-9683-64c6ae86c78d.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Deryn logo",
    "public_id": "019d744a-efb5-701c-9683-64c6ae86c78d",
    "storage_key": "property/6767906449167334/019d744a-efb5-701c-9683-64c6ae86c78d.webp",
    "width": 740,
    "height": 602
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
  "property_company_logo_media": {
    "alt_text": "AXIA RESIDENTIAL BY ARC logo",
    "public_id": "019d54d9-0a7f-7644-86f7-60a98c66fa2f",
    "storage_key": "company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
    "width": 3072,
    "height": 1849
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "AXIA Residential by ARC logo",
    "public_id": "019d54d9-c530-7559-a71a-a1a4613d29fc",
    "storage_key": "company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
    "width": 125,
    "height": 75
  },
  "property_primary_color": "#242424",
  "property_secondary_color": "#373737",
  "property_font_color": "#464646",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 3",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "3",
  "property_sqft_range": "419 - 1256",
  "property_sqft_min": "419",
  "property_sqft_max": "1256",
  "property_price_range": "$599 - $2035",
  "property_price_min": "599",
  "property_price_max": "2035",
  "property_available_units": 47,
  "property_facebook_url": "https://www.facebook.com/people/Live-At-The-Deryn/61591723175360/",
  "property_instagram_url": "https://www.instagram.com/liveatthederyn/",
  "property_twitter_url": "https://x.com/liveatthederyn",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ5dFJQH_z9YgRFEIqksdeQs4",
  "property_youtube_url": "https://www.youtube.com/watch?v=CuqHfZIdt5M",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Gainesville%2C+GA",
  "property_tiktok_url": "https://www.tiktok.com/@liveatthederyn",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Deryn",
  "property_home_romance_title": "Embrace Your New Lifestyle at Our Charming Apartment Community",
  "property_home_amenities_blurb": "Welcome to The Deryn in Gainesville, GA, where comfort meets convenience. Choose from spacious one to three-bedroom apartments, all equipped with modern amenities. Enjoy your days lounging poolside, staying active in our fitness center, or unwinding by the fire pits. Experience a vibrant community tailored for you.",
  "property_home_floorplans_blurb": "At The Deryn in Gainesville, GA, a harmonious balance of style and comfort awaits you. Choose from our inviting one-bedroom or spacious three-bedroom apartments, each designed for modern living. Browse our available homes today and uncover the ideal floor plan that feels just right for you.",
  "property_home_gallery_blurb": "At The Deryn in Gainesville, GA, your ideal lifestyle awaits. Enjoy sun-soaked afternoons by our sparkling swimming pool, grill with friends by the fire pits, or stay active in our fully-equipped fitness center. With pet-friendly, furnished apartments just a half-mile from UNG, picture yourself living here!",
  "property_home_neighborhood_blurb": "At The Deryn in Gainesville, GA, your lifestyle thrives amid vibrant local attractions. Unwind at Lanier Point Park, engage in fitness at Planet Fitness, or catch an event at the Northeast Georgia History Center. With one and three-bedroom floor plans, your perfect home awaits in a bustling neighborhood full of life.",
  "property_home_reviews_blurb": "At The Deryn in Gainesville, GA, residents rave about the vibrant community atmosphere, stating, “It feels like home from day one.” Join a neighborhood where comfort meets convenience, and experience the charm that has everyone talking. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At The Deryn in Gainesville, GA, vibrant living meets community charm. Nestled among cultural gems, enjoy proximity to the University of North Georgia, Brenau University, and the Hall County Library. Embrace an active lifestyle at nearby parks, fitness centers, and the Allen Creek Soccer Stadium, where every day unveils local wonders.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At The Deryn in Gainesville, GA, immerse yourself in a vibrant lifestyle with top-tier amenities like a refreshing swimming pool, state-of-the-art fitness center, and inviting fire pits. Our pet-friendly apartments feature modern finishes and conveniences, ensuring comfort and style—perfectly situated just a half mile from campus.",
  "property_applynow_blurb": "At The Deryn in Gainesville, GA, our diverse floor plans cater to your lifestyle—whether you seek a cozy one-bedroom or a spacious three-bedroom. Enjoy resort-style amenities like a sparkling swimming pool, vibrant fire pits, and a well-equipped fitness center. Your perfect home awaits; lease online today!",
  "property_contactus_blurb": "At The Deryn in Gainesville, GA, each floor plan—whether cozy one-bedroom or spacious three-bedroom—reflects our commitment to comfort and style. Explore a lifestyle tailored just for you. Have questions? Reach out to our friendly leasing team today and let's find your perfect home!",
  "property_faqs_blurb": "At The Deryn in Gainesville, GA, choose from spacious one or three-bedroom floor plans tailored to your lifestyle. Have questions? Our FAQs page is your go-to resource for insights into our vibrant community and living experience. Join us and find the perfect home for your next chapter!",
  "property_floorplans_blurb": "At The Deryn in Gainesville, GA, we offer an array of thoughtfully designed floor plans, from cozy one-bedroom retreats to spacious three-bedroom havens. Each apartment exudes comfort and style. Browse our available homes today and uncover the ideal space that mirrors your lifestyle and aspirations!",
  "property_gallery_blurb": "At The Deryn in Gainesville, GA, indulge in a lifestyle that blends comfort and convenience. With spacious one and three-bedroom floor plans, a vibrant swimming pool, and cozy fire pits, your ideal home awaits. Picture yourself in our pet-friendly community, just a half-mile from campus, where every detail caters to your lifestyle!",
  "property_interactivemap_blurb": "Welcome to The Deryn in Gainesville, GA, where comfort meets convenience. Choose from our spacious one- and three-bedroom floor plans, complete with pet-friendly options. Enjoy top-notch amenities, including a sparkling swimming pool, fitness center, and fire pits. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "<p>At The Deryn, we know pets are part of the family, and we’re happy to welcome them in select apartment homes throughout our community. Our thoughtfully designed residences and amenities are created to ensure both you and your furry companion feel comfortable and at home. Pet eligibility varies by apartment type. Select residences, including our co-living homes, allow one (1) pet per private room with management approval. Furnished apartment homes are not pet eligible. For additional details or to confirm availability, our leasing team is always happy to assist.</p>",
  "property_referafriend_blurb": "At The Deryn in Gainesville, GA, you’ll find the perfect blend of comfort and style with our thoughtfully designed one and three-bedroom floor plans. Embrace the joy of community—refer a friend today and create lasting memories in a place where great friends make great neighbors!",
  "property_residentaccess_blurb": "Welcome to The Deryn in Gainesville, GA, where luxury meets convenience. Choose from our thoughtfully designed one and three-bedroom floor plans to suit your lifestyle. Access your resident portal effortlessly to pay rent, schedule maintenance, and enjoy all the benefits of community living. Your new home awaits! ",
  "property_reviews_blurb": "At The Deryn in Gainesville, GA, residents love their new home! One resident raves, \"The Deryn offers unmatched comfort and community spirit.\" Experience an inviting atmosphere and top-notch amenities that make everyday living a joy. See what our residents have to say about living at our community!",
  "property_created_at": "1775246688129",
  "property_scheduletour_blurb": "At The Deryn in Gainesville, GA, our thoughtfully designed one- and three-bedroom floor plans blend comfort and style, catering to every lifestyle. Ready to see firsthand what makes our community special? Schedule a tour today, and hear directly from our residents about their amazing experiences living here!",
  "property_thankyou_blurb": "Thank you for reaching out to The Deryn in Gainesville, GA! Your interest means a lot to us. With unique one and three-bedroom floor plans, we have the perfect space for your next home. Expect a prompt response from our team, ready to assist you in finding your ideal apartment!",
  "property_virtualtours_blurb": "At The Deryn in Gainesville, GA, our carefully designed floor plans—ranging from spacious one-bedroom retreats to expansive three-bedroom homes—offer the perfect blend of comfort and style. Embrace a vibrant lifestyle and take a virtual tour of our community and available apartments for rent today!",
  "property_copyright": "2026 All Rights Reserved. The Deryn",
  "property_seo_title_home": "The Deryn |  Apartments in Gainesville, GA",
  "property_seo_description_home": "Welcome to The Deryn in Gainesville, GA! Choose from spacious one or three-bedroom apartments with amazing amenities. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Gainesville, GA Apartments for Rent",
  "property_seo_description_floorplans": "Discover your ideal lifestyle at The Deryn in Gainesville, GA! Choose from spacious one and three-bedroom layouts—your perfect home awaits!",
  "property_seo_title_amenities": "Amenities | Gainesville, GA Apartments for Rent",
  "property_seo_description_amenities": "Discover modern living at The Deryn in Gainesville, GA, with resort-style amenities, spacious layouts, and pet-friendly options!",
  "property_seo_title_gallery": "Gallery | Apartments in Gainesville, GA",
  "property_seo_description_gallery": "Embrace life at The Deryn in Gainesville, GA! Enjoy poolside BBQs, a fitness center, and pet-friendly living—just steps from campus. Picture yourself here!",
  "property_seo_title_virtualtours": "Virtual Tours | The Deryn Apartments",
  "property_seo_description_virtualtours": "Experience The Deryn in Gainesville, GA! Take a virtual tour of our inviting one and three-bedroom apartments, stylish living awaits you here!",
  "property_seo_title_interactivemap": "Interactive Map | The Deryn Apartments",
  "property_seo_description_interactivemap": "Find your perfect space at The Deryn in Gainesville, GA! Enjoy beautiful floor plans, top-notch amenities, and an interactive map for easy leasing.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Gainesville, GA",
  "property_seo_description_neighborhood": "Experience Gainesville, GA at The Deryn. Uncover local gems and attractions right outside your door—your perfect neighborhood awaits!",
  "property_seo_title_contact": "Contact Us | The Deryn",
  "property_seo_description_contact": "Connect with The Deryn in Gainesville, GA! Inquire about our one and three-bedroom floor plans today. Your ideal home awaits—reach out now!",
  "property_seo_title_faqs": "FAQs | Apartments in Gainesville, GA",
  "property_seo_description_faqs": "Uncover the answers to your questions at The Deryn in Gainesville, GA. From floor plans to amenities, our FAQs page has everything you need to know!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Gainesville, GA",
  "property_seo_description_reviews": "Experience life at The Deryn in Gainesville, GA! Our vibrant community offers spacious floor plans, top-notch amenities, and glowing resident reviews. Join us!",
  "property_seo_title_applynow": "Apply Now | Apartments in Gainesville, GA",
  "property_seo_description_applynow": "Experience comfort at The Deryn in Gainesville, GA. Choose from stylish floor plans, enjoy poolside amenities, and live steps from UNG! Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | The Deryn",
  "property_seo_description_residentaccess": "Access your resident portal at The Deryn in Gainesville, GA, to effortlessly pay rent, schedule maintenance, and manage your community life with ease!",
  "property_seo_title_referafriend": "Refer A Friend | The Deryn",
  "property_seo_description_referafriend": "Refer a friend to The Deryn in Gainesville, GA! Great friends become great neighbors—spread the word and enjoy vibrant community living together!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Deryn",
  "property_seo_description_scheduletour": "Experience luxury living at The Deryn in Gainesville, GA. Schedule a tour today to see your new home, complete with modern amenities and scenic views!",
  "property_seo_title_privacy": "Privacy Policy | The Deryn",
  "property_seo_description_privacy": "Your privacy matters at The Deryn in Gainesville, GA. Learn how we protect your information and ensure a safe living experience. View our privacy policy today.",
  "property_seo_title_accessibility": "Website Accessibility | The Deryn",
  "property_seo_description_accessibility": "At The Deryn, we prioritize accessibility for all. Join us in creating an inclusive community in Gainesville, GA, where everyone feels at home.",
  "property_seo_title_sitemap": "Sitemap | The Deryn",
  "property_seo_description_sitemap": "Navigate your way to comfort at The Deryn in Gainesville, GA. Check our sitemap for a seamless experience and discover your future home today!",
  "property_seo_title_thankyou": "Thank You | The Deryn",
  "property_seo_description_thankyou": "Thank you for reaching out to The Deryn in Gainesville, GA! Our team will be in touch soon to help you find your perfect new home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Gainesville, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791733457798",
  "amenities": [
    {
      "id": "custom_2c253ef8-481e-457f-8aca-3d7e60d98cbb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "external_id": "false",
      "title": "Poolside Grilling",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f4e9e7dc-4360-4808-b3ca-95f86873c62a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "external_id": "false",
      "title": "Vending",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c3b51c51-396b-44be-90d5-4ebc4980518b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3e8bf4e8-37de-43a4-a978-15dae0157d03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center with Free Weights",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0d18d581-2650-4cc2-bcf3-e0e43747a612",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "external_id": "false",
      "title": "Fire Pits and Outdoor Grills",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e9a0ddf2-2428-4da4-adbc-5c7134109422",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "external_id": "false",
      "title": "High Speed Internet",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eb6db8e5-760e-40f7-92ca-89692ce4c5aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center and Community Study",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bab608e9-4580-403b-8de2-e4fd737598c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "external_id": "false",
      "title": "Bike Racks",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c006fd2c-b133-4379-b682-2a7695fc69ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "external_id": "false",
      "title": "On‑Site Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7b73e4c6-ea74-4717-be1f-f594d35beba0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "external_id": "false",
      "title": "On‑Site Management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_064f739b-37df-4574-a0ce-3dd272e87a43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "external_id": "false",
      "title": "Package Receiving",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_119612da-db74-408d-867b-53046c477303",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "external_id": "false",
      "title": "Shuttle to UNG",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c07e1f4f-f6ff-4639-b2ac-3e9847efb8b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "external_id": "false",
      "title": "Half Mile from Campus",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2e60ad48-a536-488e-a9a2-1e2c2ea6e337",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "external_id": "false",
      "title": "Individual Leases",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_279b8985-8aff-41da-bdc5-ef1ceaa57360",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "external_id": "false",
      "title": "Pet‑Friendly Apartments",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a7305d27-ffaf-4801-9491-d7eaf542f1dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "external_id": "false",
      "title": "Short‑Term Leases Available with Added Fees",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_52dc01fc-e9ce-43f0-b7b6-d4e452662717",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "external_id": "false",
      "title": "Cable & Internet Included",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b30c57a6-8f9a-4df9-8c55-25bfe77f726a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "external_id": "false",
      "title": "Furnished Apartments *",
      "amount": "false",
      "description": "Only in select apartment homes.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c1e14071-6a24-4500-9c71-302139137559",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "external_id": "false",
      "title": "Valet Trash Service",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0d12431a-319b-41dc-987b-424a85dda938",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "external_id": "false",
      "title": "Central Air Conditioner",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2a498a15-ba1b-4b4c-bb92-30e25d6af0e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d4e99e45-4222-49d6-b0ed-e69910d31653",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ee7c105a-672e-4267-8959-738327239c76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_18e3ffa0-d316-45d4-87c9-1368d32b8a02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "external_id": "false",
      "title": "Wood Vinyl Plank",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3666c13c-c3ea-4b88-96eb-e11941d6fbb1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "external_id": "false",
      "title": "Private Bathrooms",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d6a170fd-0ebe-41a0-bc61-c8a7b4fa0a9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "external_id": "false",
      "title": "Full‑Sized Washer and Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_7f9f639f-c241-466d-bf76-a044c0d31f9f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019fb454-9994-7589-902a-eb7a6ed452b4.webp",
      "image_media": {
        "alt_text": "Empty bedroom with light gray walls, a ceiling fan, and a window with blinds.",
        "public_id": "019fb454-9994-7589-902a-eb7a6ed452b4",
        "storage_key": "property/6767906449167334/019fb454-9994-7589-902a-eb7a6ed452b4.webp",
        "width": 1280,
        "height": 720
      },
      "title": "Apartment",
      "description": "Spacious bedroom with neutral gray walls, plush carpeting, a ceiling fan for comfort, and a large window allowing natural light.",
      "link": "",
      "alt_text": "Empty bedroom with light gray walls, a ceiling fan, and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b304d9c2-f56d-4611-a791-3b2df62cd40c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d744e-4055-721d-b150-e763cc776c8b.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and bathtub at The Deryn Gainesville, GA.",
        "public_id": "019d744e-4055-721d-b150-e763cc776c8b",
        "storage_key": "property/6767906449167334/019d744e-4055-721d-b150-e763cc776c8b.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Bright and clean bathroom featuring a sleek vanity with a large mirror, a modern toilet, and a white bathtub with a shower.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and bathtub at The Deryn Gainesville, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_35d6de51-6468-4808-adc9-4628b3bb05ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d744e-4400-74fe-826d-50d42b6feba6.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment  at The Deryn Gainesville, GA.",
        "public_id": "019d744e-4400-74fe-826d-50d42b6feba6",
        "storage_key": "property/6767906449167334/019d744e-4400-74fe-826d-50d42b6feba6.webp",
        "width": 1280,
        "height": 720
      },
      "title": "Apartment",
      "description": "Spacious living room and modern kitchen area with stainless steel appliances. This apartment offers a comfortable and stylish living space.",
      "link": "",
      "alt_text": "Living room and kitchen area of an apartment  at The Deryn Gainesville, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3f6179f8-652c-4192-b59f-f3e1d71c7466",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d744e-40aa-773b-bc71-4ac568b03708.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops  at The Deryn Gainesville, GA.",
        "public_id": "019d744e-40aa-773b-bc71-4ac568b03708",
        "storage_key": "property/6767906449167334/019d744e-40aa-773b-bc71-4ac568b03708.webp",
        "width": 1280,
        "height": 720
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring sleek stainless steel appliances, ample cabinet space, and elegant granite countertops for a sophisticated cooking experience.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops  at The Deryn Gainesville, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_96549e32-7188-4ea9-b057-c590247a8a24",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d744e-4122-70de-9cc6-a18663e5ad33.webp",
      "image_media": {
        "alt_text": "Empty room with a ceiling fan and a large window at The Deryn Gainesville, GA.",
        "public_id": "019d744e-4122-70de-9cc6-a18663e5ad33",
        "storage_key": "property/6767906449167334/019d744e-4122-70de-9cc6-a18663e5ad33.webp",
        "width": 1280,
        "height": 720
      },
      "title": "Apartment",
      "description": "Spacious empty room featuring a ceiling fan and blinds on a large window, offering a blank canvas for your personal style.",
      "link": "",
      "alt_text": "Empty room with a ceiling fan and a large window at The Deryn Gainesville, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f3dec579-7ffb-4496-9ca0-8b591bd2f5e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019fb454-99dd-712a-a307-c6c4246935e4.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, and free weights  at The Deryn Gainesville, GA.",
        "public_id": "019fb454-99dd-712a-a307-c6c4246935e4",
        "storage_key": "property/6767906449167334/019fb454-99dd-712a-a307-c6c4246935e4.webp",
        "width": 1280,
        "height": 720
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring treadmills, an elliptical machine, and a selection of free weights for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, and free weights  at The Deryn Gainesville, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_08e03431-b3fd-4ac2-b2a4-edbae5abe776",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d744e-3157-755d-a37a-10b489c3faf6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel sink, and black dishwasher at The Deryn Gainesville, GA",
        "public_id": "019d744e-3157-755d-a37a-10b489c3faf6",
        "storage_key": "property/6767906449167334/019d744e-3157-755d-a37a-10b489c3faf6.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this updated kitchen featuring sleek white cabinetry, durable granite countertops, and modern appliances including a dishwasher.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel sink, and black dishwasher at The Deryn Gainesville, GA",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_429f08c1-d402-4e44-8abe-276111b4f923",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d744e-2f3f-7251-bfcc-3c68af037528.webp",
      "image_media": {
        "alt_text": "A bedroom with a twin bed, desk, and window at The Deryn Gainesville, GA.",
        "public_id": "019d744e-2f3f-7251-bfcc-3c68af037528",
        "storage_key": "property/6767906449167334/019d744e-2f3f-7251-bfcc-3c68af037528.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "A cozy bedroom featuring a comfortable twin bed, a functional desk space, and ample natural light from a large window.",
      "link": "",
      "alt_text": "A bedroom with a twin bed, desk, and window at The Deryn Gainesville, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_57f0f0fc-b7ee-4490-a74d-faeb8fd7882a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d744e-290e-72ef-afba-38c4d108a1f7.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan and double-door closet  at The Deryn Gainesville, GA.",
        "public_id": "019d744e-290e-72ef-afba-38c4d108a1f7",
        "storage_key": "property/6767906449167334/019d744e-290e-72ef-afba-38c4d108a1f7.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, plush carpeting, and ample closet space with double doors.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan and double-door closet  at The Deryn Gainesville, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1a836d3b-50b9-4bf0-879a-03af92997eff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d744e-2935-752a-9d0b-a163820f566c.webp",
      "image_media": {
        "alt_text": "Office reception area with desks, seating, and a large blue abstract mural at The Deryn Gainesville, GA.",
        "public_id": "019d744e-2935-752a-9d0b-a163820f566c",
        "storage_key": "property/6767906449167334/019d744e-2935-752a-9d0b-a163820f566c.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Welcome to our leasing office, where our friendly team is ready to assist you. Enjoy the modern design and comfortable atmosphere as you explore your new home options.",
      "link": "",
      "alt_text": "Office reception area with desks, seating, and a large blue abstract mural at The Deryn Gainesville, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_83c1671e-d606-4dfa-9a47-5784f1f5cadd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d744e-2901-769e-a2e2-8d80b17bced3.webp",
      "image_media": {
        "alt_text": "Business center with computers, printers, and seating  at The Deryn Gainesville, GA.",
        "public_id": "019d744e-2901-769e-a2e2-8d80b17bced3",
        "storage_key": "property/6767906449167334/019d744e-2901-769e-a2e2-8d80b17bced3.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Utilize our state-of-the-art business center, equipped with computers, printers, and comfortable seating for all your professional needs.",
      "link": "",
      "alt_text": "Business center with computers, printers, and seating  at The Deryn Gainesville, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_346055df-0b08-4c63-89c0-bbc14d6c678c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d744e-1f85-730a-b348-8cdfe84462aa.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas on a sunny day at The Deryn Gainesville, GA",
        "public_id": "019d744e-1f85-730a-b348-8cdfe84462aa",
        "storage_key": "property/6767906449167334/019d744e-1f85-730a-b348-8cdfe84462aa.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and shaded umbrellas. Perfect for a sunny day getaway.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas on a sunny day at The Deryn Gainesville, GA",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4b4b980d-eb01-4878-a288-32202ddd5a72",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d744e-199f-757e-98ef-6ce6deb24e22.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and outdoor grill area  at The Deryn Gainesville, GA.",
        "public_id": "019d744e-199f-757e-98ef-6ce6deb24e22",
        "storage_key": "property/6767906449167334/019d744e-199f-757e-98ef-6ce6deb24e22.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy sunny days by the sparkling swimming pool, complete with comfortable lounge chairs and a convenient outdoor grilling station. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and outdoor grill area  at The Deryn Gainesville, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8e4bea73-7a2b-46f2-8b70-bc8d149dff28",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d744e-1b8f-757e-bdaa-2a521273bc8e.webp",
      "image_media": {
        "alt_text": "Empty bedroom with plush carpet, ceiling fan, and closet  at The Deryn Gainesville, GA.",
        "public_id": "019d744e-1b8f-757e-bdaa-2a521273bc8e",
        "storage_key": "property/6767906449167334/019d744e-1b8f-757e-bdaa-2a521273bc8e.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious bedroom with soft carpeting, a ceiling fan for comfort, and ample closet space.",
      "link": "",
      "alt_text": "Empty bedroom with plush carpet, ceiling fan, and closet  at The Deryn Gainesville, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fcb6a472-ae49-439c-9a60-0c4b9b33bf71",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d744e-19ad-724a-8289-19d62c74e7da.webp",
      "image_media": {
        "alt_text": "Exterior building entrance with brick facade, blue shutters, and landscaping at The Deryn Gainesville, GA",
        "public_id": "019d744e-19ad-724a-8289-19d62c74e7da",
        "storage_key": "property/6767906449167334/019d744e-19ad-724a-8289-19d62c74e7da.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Charming brick building entrance with beautiful landscaping, featuring blue shutters and well-maintained grounds.",
      "link": "",
      "alt_text": "Exterior building entrance with brick facade, blue shutters, and landscaping at The Deryn Gainesville, GA",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dfbdd903-5add-4aa6-98f0-3cb0cbcf240f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d744e-1923-742d-aa60-da6c3f1cf933.webp",
      "image_media": {
        "alt_text": "Living room with gray sectional sofa, coffee table, TV, and abstract art at The Deryn Gainesville, GA.",
        "public_id": "019d744e-1923-742d-aa60-da6c3f1cf933",
        "storage_key": "property/6767906449167334/019d744e-1923-742d-aa60-da6c3f1cf933.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious and modern living room featuring a comfortable gray sectional sofa, a stylish coffee table, and entertainment center with a television, all complemented by decorative artwork.",
      "link": "",
      "alt_text": "Living room with gray sectional sofa, coffee table, TV, and abstract art at The Deryn Gainesville, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d0a8aad8-4ac7-4c79-b911-8f24e0213dda",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d744e-1903-708d-9a6e-6168b136cbf0.webp",
      "image_media": {
        "alt_text": "Aerial view of a pristine swimming pool with lounge chairs and patio tables at The Deryn Gainesville, GA",
        "public_id": "019d744e-1903-708d-9a6e-6168b136cbf0",
        "storage_key": "property/6767906449167334/019d744e-1903-708d-9a6e-6168b136cbf0.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with ample lounge seating and outdoor dining areas for relaxation and socializing.",
      "link": "",
      "alt_text": "Aerial view of a pristine swimming pool with lounge chairs and patio tables at The Deryn Gainesville, GA",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f4d6554b-f659-444e-87c9-e0bac1a0b72f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019f196f-f820-71e8-b516-1b89c4ff5c10.webp",
      "image_media": {
        "alt_text": "Adirondack chairs surrounding a stone fire pit in a grassy courtyard.",
        "public_id": "019f196f-f820-71e8-b516-1b89c4ff5c10",
        "storage_key": "property/6767906449167334/019f196f-f820-71e8-b516-1b89c4ff5c10.webp",
        "width": 700,
        "height": 500
      },
      "title": "Community",
      "description": "Gather around the stone fire pit with comfortable Adirondack chairs, perfect for cozy evenings outdoors.",
      "link": "",
      "alt_text": "Adirondack chairs surrounding a stone fire pit in a grassy courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_33bd5b45-86a0-437e-a0d9-16d8988e741c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019f196f-f55d-7499-a31c-ffbd01dc675c.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, desk, and closet.",
        "public_id": "019f196f-f55d-7499-a31c-ffbd01dc675c",
        "storage_key": "property/6767906449167334/019f196f-f55d-7499-a31c-ffbd01dc675c.webp",
        "width": 700,
        "height": 500
      },
      "title": "Apartment",
      "description": "A cozy bedroom featuring a comfortable bed, a functional desk, and ample closet space.",
      "link": "",
      "alt_text": "Bedroom with a bed, desk, and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cd8e97a3-423b-4182-9364-1178b58e440d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019f196f-f94f-71bc-a7da-5995e092f03b.webp",
      "image_media": {
        "alt_text": "Kitchen with breakfast bar, black appliances, wooden cabinets, and three bar stools.",
        "public_id": "019f196f-f94f-71bc-a7da-5995e092f03b",
        "storage_key": "property/6767906449167334/019f196f-f94f-71bc-a7da-5995e092f03b.webp",
        "width": 700,
        "height": 500
      },
      "title": "Apartment",
      "description": "Discover your new kitchen, complete with a breakfast bar, sleek black appliances, and warm wooden cabinetry. Perfect for entertaining or enjoying a casual meal.",
      "link": "",
      "alt_text": "Kitchen with breakfast bar, black appliances, wooden cabinets, and three bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_56763015-c43e-423d-b94c-5e81b97b0df4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019f196f-f4a8-716d-838d-3b079249d2ff.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, shower/tub with floral curtain, and nearby linen closet with shelving and folded towels.",
        "public_id": "019f196f-f4a8-716d-838d-3b079249d2ff",
        "storage_key": "property/6767906449167334/019f196f-f4a8-716d-838d-3b079249d2ff.webp",
        "width": 700,
        "height": 500
      },
      "title": "Apartment",
      "description": "Relax and refresh in our modern bathrooms, featuring convenient amenities like a full-size tub and shower, ample vanity space, and nearby linen storage. Experience comfort and functionality in every detail.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, shower/tub with floral curtain, and nearby linen closet with shelving and folded towels.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_676d13ef-167c-4f98-8227-ceea9dd75860",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019f196f-f81d-7022-af53-37e0b0b5c9b3.webp",
      "image_media": {
        "alt_text": "Apartment kitchen with wooden cabinets, black microwave, black electric stove, and light countertops.",
        "public_id": "019f196f-f81d-7022-af53-37e0b0b5c9b3",
        "storage_key": "property/6767906449167334/019f196f-f81d-7022-af53-37e0b0b5c9b3.webp",
        "width": 700,
        "height": 500
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen featuring wooden cabinetry, sleek black microwave, and electric stove, complemented by light-colored countertops.",
      "link": "",
      "alt_text": "Apartment kitchen with wooden cabinets, black microwave, black electric stove, and light countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_71782b01-1167-4968-9e98-776166780ad9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019f196f-f8e4-755f-b7eb-fe3a4c489ddc.webp",
      "image_media": {
        "alt_text": "View of the community outdoor swimming pool with lounge chairs, shaded seating, and apartment buildings.",
        "public_id": "019f196f-f8e4-755f-b7eb-fe3a4c489ddc",
        "storage_key": "property/6767906449167334/019f196f-f8e4-755f-b7eb-fe3a4c489ddc.webp",
        "width": 700,
        "height": 500
      },
      "title": "Community",
      "description": "Enjoy sunny days at our refreshing outdoor swimming pool, featuring ample lounge seating, shaded tables, and a BBQ grill area for residents. The perfect spot to unwind and socialize.",
      "link": "",
      "alt_text": "View of the community outdoor swimming pool with lounge chairs, shaded seating, and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e4b97389-1f3e-470a-b383-6b35209f0d24",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019f196f-f76f-71dd-b5d3-76be329d7202.webp",
      "image_media": {
        "alt_text": "Apartment kitchen with wooden cabinets, black dishwasher, and a view into the living room with a gray sofa.",
        "public_id": "019f196f-f76f-71dd-b5d3-76be329d7202",
        "storage_key": "property/6767906449167334/019f196f-f76f-71dd-b5d3-76be329d7202.webp",
        "width": 700,
        "height": 500
      },
      "title": "Apartment",
      "description": "Experience comfortable living with a well-appointed kitchen featuring stylish wooden cabinetry, modern black appliances, and an open layout connecting to the inviting living area.",
      "link": "",
      "alt_text": "Apartment kitchen with wooden cabinets, black dishwasher, and a view into the living room with a gray sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b9535feb-59a0-4988-8b55-79a32a4e4341",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019f196f-f4a8-716d-838d-3c885f3dc91b.webp",
      "image_media": {
        "alt_text": "A multi-story brick apartment building with white-framed windows, dark shutters, and a parking lot with cars under a blue sky.",
        "public_id": "019f196f-f4a8-716d-838d-3c885f3dc91b",
        "storage_key": "property/6767906449167334/019f196f-f4a8-716d-838d-3c885f3dc91b.webp",
        "width": 700,
        "height": 500
      },
      "title": "Community",
      "description": "View of the apartment community's attractive brick exterior and convenient parking lot, showcasing the property's inviting curb appeal for residents.",
      "link": "",
      "alt_text": "A multi-story brick apartment building with white-framed windows, dark shutters, and a parking lot with cars under a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_260cfa04-936c-438f-8247-a406b1995516",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019f1970-0593-729c-9eb8-9163a7aed1fa.webp",
      "image_media": {
        "alt_text": "Row of lounge chairs by a swimming pool with a brick building in the background.",
        "public_id": "019f1970-0593-729c-9eb8-9163a7aed1fa",
        "storage_key": "property/6767906449167334/019f1970-0593-729c-9eb8-9163a7aed1fa.webp",
        "width": 700,
        "height": 500
      },
      "title": "Community",
      "description": "Relax by the outdoor swimming pool with plenty of lounge chairs available for sunbathing and unwinding.",
      "link": "",
      "alt_text": "Row of lounge chairs by a swimming pool with a brick building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2f3e9d48-5d0e-47b3-a90f-a605b8fb3a07",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019f196f-f4aa-73ba-92e8-085bc60230f4.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building entrance with brick facade and colorful flower beds.",
        "public_id": "019f196f-f4aa-73ba-92e8-085bc60230f4",
        "storage_key": "property/6767906449167334/019f196f-f4aa-73ba-92e8-085bc60230f4.webp",
        "width": 700,
        "height": 500
      },
      "title": "Community",
      "description": "Charming brick building entrance featuring vibrant flower beds and lush greenery, offering a welcoming first impression.",
      "link": "",
      "alt_text": "Exterior view of apartment building entrance with brick facade and colorful flower beds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_87ef5e1c-36e2-4321-8fff-dba4e6cb3f43",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019f196f-f2b4-737c-a236-4f20d606de3f.webp",
      "image_media": {
        "alt_text": "Washer and dryer with laundry supplies on shelf above",
        "public_id": "019f196f-f2b4-737c-a236-4f20d606de3f",
        "storage_key": "property/6767906449167334/019f196f-f2b4-737c-a236-4f20d606de3f.webp",
        "width": 700,
        "height": 500
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer with shelf for laundry supplies.",
      "link": "",
      "alt_text": "Washer and dryer with laundry supplies on shelf above",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_942f5048-d13a-4109-87f0-c22e24f4f73d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Hello Hilo",
      "poi_type": "Restaurants",
      "poi_address": "1881 Jesse Jewell Pkwy NE, Gainesville, GA 30501, USA",
      "poi_short_description": "Laid-back restaurant known for rice bowls, donuts, sliders and Hawaiian eats.",
      "poi_long_description": "People say this Hawaiian restaurant serves delicious Huli Huli chicken, spicy bulgogi sliders, and a variety of rice bowls, as well as tasty pastries, donuts, and Dole Whip. They also highlight the fun, tropical atmosphere, the friendly and welcoming staff, and the fast service.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f2-d438-775c-a5f4-005f1d4e6dde.webp",
      "poi_featured_image_media": {
        "alt_text": "Outdoor seating area with Aloha sign and tropical decor.",
        "public_id": "019d54f2-d438-775c-a5f4-005f1d4e6dde",
        "storage_key": "property/6767906449167334/019d54f2-d438-775c-a5f4-005f1d4e6dde.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.hellohiloeats.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18314421651243303622&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hello-hilo",
      "poi_latitude": "34.3118701",
      "poi_longitude": "-83.79754870000001",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 470-712-4456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-823c-71cb-ae2f-a8a8db371275.webp",
      "poi_map_icon_media": {
        "alt_text": "Fork and knife icon",
        "public_id": "019d54f3-823c-71cb-ae2f-a8a8db371275",
        "storage_key": "property/6767906449167334/019d54f3-823c-71cb-ae2f-a8a8db371275.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAUjW6n_39YgRxoIUNXXlKf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hawaiian_restaurant"
    },
    {
      "id": "custom_4cc53a53-01a1-4585-98a4-687ea84d72b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "1450 Browns Bridge Rd, Gainesville, GA 30501, USA",
      "poi_short_description": "Family-friendly buffet chain featuring all-you-can-eat American fare, plus salad & dessert bars.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of fresh and delicious food, including a salad bar, fresh fruit, baked fish, chicken, and turkey. They also highlight the clean and well-stocked bars, and the friendly, attentive, and efficient service.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f2-cb17-72ce-aa2e-340ffa78dcc9.webp",
      "poi_featured_image_media": {
        "alt_text": "Golden Corral restaurant exterior at dusk with cars in the parking lot and people entering.",
        "public_id": "019d54f2-cb17-72ce-aa2e-340ffa78dcc9",
        "storage_key": "property/6767906449167334/019d54f2-cb17-72ce-aa2e-340ffa78dcc9.webp",
        "width": 960,
        "height": 721
      },
      "poi_business_url": "https://www.goldencorral.com/locations/2690/golden-corral-browns-bridge-road/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=2690",
      "poi_directions_map_url": "https://maps.google.com/?cid=14823479439098470387&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "34.286452",
      "poi_longitude": "-83.8418952",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 678-928-4098",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-823c-71cb-ae2f-a8a8db371275.webp",
      "poi_map_icon_media": {
        "alt_text": "Fork and knife icon",
        "public_id": "019d54f3-823c-71cb-ae2f-a8a8db371275",
        "storage_key": "property/6767906449167334/019d54f3-823c-71cb-ae2f-a8a8db371275.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHxhiQOf39YgR81_F_gKUt80",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_a366ffbf-5b27-4d4b-aff7-fda6c3ad8b2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Pelican Pete's Tiki Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "8800 Port Royale Dr, Gainesville, GA 30506, USA",
      "poi_short_description": "Burgers & cocktails served in a dockside gathering place with sunset views & live entertainment.",
      "poi_long_description": "Diners say this bar and grill serves up delicious fish tacos, burgers, and coconut shrimp, and they praise the lively atmosphere with live music and waterfront views. They also highlight the friendly and attentive service, and many appreciate the dog-friendly patio seating.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f2-cba3-77ce-bee6-68747ef8bfc6.webp",
      "poi_featured_image_media": {
        "alt_text": "Entrance to Pelican Pete's waterfront restaurant with people dining outside.",
        "public_id": "019d54f2-cba3-77ce-bee6-68747ef8bfc6",
        "storage_key": "property/6767906449167334/019d54f2-cba3-77ce-bee6-68747ef8bfc6.webp",
        "width": 3000,
        "height": 1996
      },
      "poi_business_url": "https://www.pelicanpetes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=620636927180910130&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pelican-petes-tiki-bar--grill",
      "poi_latitude": "34.2433778",
      "poi_longitude": "-83.9616827",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 47 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 770-887-5715",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8250-7042-b6d9-9eb522a7746f.webp",
      "poi_map_icon_media": {
        "alt_text": "Martini glass icon",
        "public_id": "019d54f3-8250-7042-b6d9-9eb522a7746f",
        "storage_key": "property/6767906449167334/019d54f3-8250-7042-b6d9-9eb522a7746f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgQ1EV4yM9YgRMq4bO__xnAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_371f514b-9c82-432f-8692-4250fb95fd1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "895 Dawsonville Hwy, Gainesville, GA 30501, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and salmon, and they highlight the hot, buttery rolls with cinnamon butter. They also like the friendly and attentive staff, and the clean restaurant and restrooms.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f2-cb49-7638-bded-c0176206ec82.webp",
      "poi_featured_image_media": {
        "alt_text": "Texas Roadhouse restaurant building exterior with American and Texas flags.",
        "public_id": "019d54f2-cb49-7638-bded-c0176206ec82",
        "storage_key": "property/6767906449167334/019d54f2-cb49-7638-bded-c0176206ec82.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/georgia/gainesville?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=17359778811686522236&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "34.2977594",
      "poi_longitude": "-83.85716239999999",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 678-450-8447",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-823c-71cb-ae2f-a8a8db371275.webp",
      "poi_map_icon_media": {
        "alt_text": "Fork and knife icon",
        "public_id": "019d54f3-823c-71cb-ae2f-a8a8db371275",
        "storage_key": "property/6767906449167334/019d54f3-823c-71cb-ae2f-a8a8db371275.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ5teJST09YgRfI3tadpS6vA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_4d3ae2df-8a7f-4283-8fad-cb6103e10c6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Cheddar's Scratch Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "1195 Dawsonville Hwy, Gainesville, GA 30501, USA",
      "poi_short_description": "Family-friendly chain serving American comfort food with a Texas twist, plus cocktails.",
      "poi_long_description": "People say this restaurant serves delicious chicken pot pie, pecan chicken salad, and bourbon salmon with shrimp. They also highlight the reasonable prices, large portions, and friendly staff.\n\nOther reviews mention the food can be over-salted.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f2-d414-759e-a701-f2ac60f56035.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of Cheddar's Scratch Kitchen restaurant building with stone facade and prominent signage.",
        "public_id": "019d54f2-d414-759e-a701-f2ac60f56035",
        "storage_key": "property/6767906449167334/019d54f2-d414-759e-a701-f2ac60f56035.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.cheddars.com/locations/ga/gainesville/gainesville/2184?cmpid=br:csk_ag:ie_ch:loc_ca:CSKGMB_sn:gmb_gt:gainesville-ga-2184_pl:locurl_rd:1155",
      "poi_directions_map_url": "https://maps.google.com/?cid=13409972395973895832&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cheddars-scratch-kitchen",
      "poi_latitude": "34.3036097",
      "poi_longitude": "-83.8603152",
      "poi_miles_from_property": "17.7",
      "poi_walking_minutes": "6 hours 31 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 678-450-4510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-823c-71cb-ae2f-a8a8db371275.webp",
      "poi_map_icon_media": {
        "alt_text": "Fork and knife icon",
        "public_id": "019d54f3-823c-71cb-ae2f-a8a8db371275",
        "storage_key": "property/6767906449167334/019d54f3-823c-71cb-ae2f-a8a8db371275.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSSQZuTH09YgRmGbRVdjKGbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_44c48fa2-89c3-40c9-9d72-8c469512bd8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "924 Dawsonville Hwy, Gainesville, GA 30501, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide variety of tools, hardware, and building materials. They also highlight the helpful staff and the large, clean store.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f2-ca77-76cf-a8da-90f5ac81fa54.webp",
      "poi_featured_image_media": {
        "alt_text": "The Home Depot storefront with orange signage.",
        "public_id": "019d54f2-ca77-76cf-a8da-90f5ac81fa54",
        "storage_key": "property/6767906449167334/019d54f2-ca77-76cf-a8da-90f5ac81fa54.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Gainesville/GA/Gainesville/30501/152?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=13029671488225959610&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "34.3003838",
      "poi_longitude": "-83.85510579999999",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-532-7395",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-824e-73e6-a331-57639e393648.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d54f3-824e-73e6-a331-57639e393648",
        "storage_key": "property/6767906449167334/019d54f3-824e-73e6-a331-57639e393648.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJc2oDdi_09YgRul6-My-x0rQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_4ed3fb27-34ab-4169-a6b4-284073da2652",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Kroger Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "1931 Jesse Jewell Pkwy SE, Gainesville, GA 30501, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "People say this grocery store offers a wide selection of products, including clothing, and has a convenient layout. They also highlight the great prices and helpful staff.\n\nOther reviews mention the produce can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f2-caf9-75bd-a1f6-80df8afb6918.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a Kroger Food & Drug store with brick accents and arched entrances.",
        "public_id": "019d54f2-caf9-75bd-a1f6-80df8afb6918",
        "storage_key": "property/6767906449167334/019d54f2-caf9-75bd-a1f6-80df8afb6918.webp",
        "width": 1500,
        "height": 1004
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ga/gainesville/new-holland-market/011/00682?cid=loc_01100682_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=14249891361474847113&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kroger-marketplace",
      "poi_latitude": "34.315316",
      "poi_longitude": "-83.79817000000001",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 470-252-3182",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-825c-70a3-bd92-b3715c7978f4.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d54f3-825c-70a3-bd92-b3715c7978f4",
        "storage_key": "property/6767906449167334/019d54f3-825c-70a3-bd92-b3715c7978f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt6KDjqn39YgRiaGdsLHIwcU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_8e8bc7db-5fd9-443e-a2de-82a44733225b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Talpa Supermercados - Gainesville",
      "poi_type": "Shopping & Retail",
      "poi_address": "2277 Browns Bridge Rd, Gainesville, GA 30501, USA",
      "poi_short_description": "Clean marketplace selling meat and fish, plus bakery goods, pizza and ice cream.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, meats, and Mexican and Latin American products, including homemade tortillas, tamales, and salsas. They highlight the good prices, clean and well-organized layout, and the availability of restaurants, a bakery, and an ice cream shop within the store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f2-d3d7-73be-ac7f-37729bf8b0d1.webp",
      "poi_featured_image_media": {
        "alt_text": "People shopping at a market with \"Carnitas\" sign",
        "public_id": "019d54f2-d3d7-73be-ac7f-37729bf8b0d1",
        "storage_key": "property/6767906449167334/019d54f2-d3d7-73be-ac7f-37729bf8b0d1.webp",
        "width": 1728,
        "height": 3072
      },
      "poi_business_url": "http://www.supermercadostalpa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2714126086179262167&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "talpa-supermercados---gainesville",
      "poi_latitude": "34.2786081",
      "poi_longitude": "-83.8516176",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 470-892-2040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-825c-70a3-bd92-b3715c7978f4.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d54f3-825c-70a3-bd92-b3715c7978f4",
        "storage_key": "property/6767906449167334/019d54f3-825c-70a3-bd92-b3715c7978f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj7UjGRj19YgR1w5WmkuDqiU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b00d0b60-1b0e-40a1-9f56-d927a1520340",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "1514 Skelton Rd, Gainesville, GA 30504, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store has a wide selection of appliances, tools, and supplies for home repairs, including kitchen appliances, paint, light bulbs, cleaning supplies, and garden plants. They also highlight the helpful and friendly staff who go above and beyond to assist customers.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f2-ca70-731e-bb87-a79dd29de453.webp",
      "poi_featured_image_media": {
        "alt_text": "Lowe's logo on building exterior",
        "public_id": "019d54f2-ca70-731e-bb87-a79dd29de453",
        "storage_key": "property/6767906449167334/019d54f2-ca70-731e-bb87-a79dd29de453.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/GA-Gainesville/0434?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-434-_-na-_-0-_-0&y_source=1_MTE4NDAwMi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14585919590588009313&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "34.290636",
      "poi_longitude": "-83.8490271",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-532-1926",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-824e-73e6-a331-57639e393648.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d54f3-824e-73e6-a331-57639e393648",
        "storage_key": "property/6767906449167334/019d54f3-824e-73e6-a331-57639e393648.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZ5IZO5729YgRYctoj5aYa8o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_4dbbea41-4dac-4471-b9b5-1593eb033ca7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "University of North Georgia - Gainesville Campus",
      "poi_type": "Education",
      "poi_address": "3820 Mundy Mill Rd, Oakwood, GA 30566, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f2-e927-7306-9093-cc6dd939d284.webp",
      "poi_featured_image_media": {
        "alt_text": "Martha T. Nesbitt Academic Building exterior",
        "public_id": "019d54f2-e927-7306-9093-cc6dd939d284",
        "storage_key": "property/6767906449167334/019d54f2-e927-7306-9093-cc6dd939d284.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "https://ung.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10691497448408286501&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-north-georgia---gainesville-campus",
      "poi_latitude": "34.2347566",
      "poi_longitude": "-83.8676613",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 678-717-3639",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8236-70fa-97cd-e73dfc8cb5df.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d54f3-8236-70fa-97cd-e73dfc8cb5df",
        "storage_key": "property/6767906449167334/019d54f3-8236-70fa-97cd-e73dfc8cb5df.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZZcihcfz9YgRJQVfiUjUX5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e0ad527b-efee-4f66-80f0-df484432e305",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Brenau University",
      "poi_type": "Education",
      "poi_address": "500 Washington St SE, Gainesville, GA 30501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f2-e100-7280-bf79-81683cadc3ec.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a historic building with a large green lawn and trees in the foreground.",
        "public_id": "019d54f2-e100-7280-bf79-81683cadc3ec",
        "storage_key": "property/6767906449167334/019d54f2-e100-7280-bf79-81683cadc3ec.webp",
        "width": 2048,
        "height": 1365
      },
      "poi_business_url": "http://www.brenau.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6344588805973639156&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "brenau-university",
      "poi_latitude": "34.3041802",
      "poi_longitude": "-83.8201186",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 770-534-6299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8236-70fa-97cd-e73dfc8cb5df.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d54f3-8236-70fa-97cd-e73dfc8cb5df",
        "storage_key": "property/6767906449167334/019d54f3-8236-70fa-97cd-e73dfc8cb5df.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqQu-v_b29YgR9H_6aeeBDFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c9d36cc3-1ce1-4e33-a7c1-fb3d8675fd68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Gainesville Campus Student Center",
      "poi_type": "Education",
      "poi_address": "2622 Mathis Dr, Oakwood, GA 30566, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ung.edu/student-involvement/ung-student-centers/gainesville-campus.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=15147623806860312565&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gainesville-campus-student-center",
      "poi_latitude": "34.2352941",
      "poi_longitude": "-83.8668843",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 678-717-3622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8236-70fa-97cd-e73dfc8cb5df.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d54f3-8236-70fa-97cd-e73dfc8cb5df",
        "storage_key": "property/6767906449167334/019d54f3-8236-70fa-97cd-e73dfc8cb5df.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZzhtvMfz9YgR9b8ox5grN9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1ebd772d-a34d-4623-901f-89cfd0af7d69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Hall County Library Downtown",
      "poi_type": "Education",
      "poi_address": "127 Main St NW, Gainesville, GA 30501, USA",
      "poi_short_description": "Book-stocked public library with a children's section for kids' books and programs and a friendly staff.",
      "poi_long_description": "People say this public library offers a variety of books, activities for children and adults, and a room where books can be purchased for $1-$2. They highlight the clean and organized space, and the friendly and helpful staff. They also like the comfortable atmosphere and the availability of tech classes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f2-ed85-752a-a154-483b68191552.webp",
      "poi_featured_image_media": {
        "alt_text": "Modern apartment building exterior with large windows and a parking lot.",
        "public_id": "019d54f2-ed85-752a-a154-483b68191552",
        "storage_key": "property/6767906449167334/019d54f2-ed85-752a-a154-483b68191552.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "http://www.hallcountylibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16281106285529747331&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hall-county-library-downtown",
      "poi_latitude": "34.3001681",
      "poi_longitude": "-83.82854429999999",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 770-532-3311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8236-70fa-97cd-e73dfc8cb5df.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d54f3-8236-70fa-97cd-e73dfc8cb5df",
        "storage_key": "property/6767906449167334/019d54f3-8236-70fa-97cd-e73dfc8cb5df.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIYEfB4329YgRg09h2-cb8uE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_10dfb10f-2e50-4121-9a95-9e1ad8e09d60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Ink Interactive Neighborhood",
      "poi_type": "Entertainment",
      "poi_address": "3900 Ink Ave, Oakwood, GA 30566, USA",
      "poi_short_description": "Lively children’s museum featuring interactive exhibits, a pottery studio, toy library & gift shop.",
      "poi_long_description": "People say this children's museum offers a wide variety of interactive exhibits and activities, including a kid-sized town, vehicles, and themed stations. They highlight the spacious layout, clean facilities, and fun experience for children of various ages. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f2-e79e-7388-a839-ed6563c8e5b8.webp",
      "poi_featured_image_media": {
        "alt_text": "Two young girls playing in a toy helicopter.",
        "public_id": "019d54f2-e79e-7388-a839-ed6563c8e5b8",
        "storage_key": "property/6767906449167334/019d54f2-e79e-7388-a839-ed6563c8e5b8.webp",
        "width": 480,
        "height": 640
      },
      "poi_business_url": "http://www.inkfun.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3317437904184636906&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ink-interactive-neighborhood",
      "poi_latitude": "34.22942190000001",
      "poi_longitude": "-83.8840177",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 770-536-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-823f-7333-83bd-42c6a002612a.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon with letter M inside",
        "public_id": "019d54f3-823f-7333-83bd-42c6a002612a",
        "storage_key": "property/6767906449167334/019d54f3-823f-7333-83bd-42c6a002612a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJFRpOT-b29YgR6nVXgzLoCS4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_c0579642-ed28-4c30-a9f3-c595e73a0728",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Allen Creek Soccer Stadium",
      "poi_type": "Entertainment",
      "poi_address": "2500 Allen Creek Rd, Gainesville, GA 30507, USA",
      "poi_short_description": "This 89-acre outdoor facility boasting multiple soccer fields hosts games, tournaments & camps.",
      "poi_long_description": "This 89-acre outdoor facility boasting multiple soccer fields hosts games, tournaments & camps.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f2-f3cd-71ee-bfe5-a1981000c322.webp",
      "poi_featured_image_media": {
        "alt_text": "Soccer game at night under bright stadium lights with players on the field.",
        "public_id": "019d54f2-f3cd-71ee-bfe5-a1981000c322",
        "storage_key": "property/6767906449167334/019d54f2-f3cd-71ee-bfe5-a1981000c322.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2581441684508310193&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "allen-creek-soccer-stadium",
      "poi_latitude": "34.2642131",
      "poi_longitude": "-83.7924044",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 678-450-6502",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8242-77af-b23f-9088325853a5.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon representing two people sitting across from each other at a table.",
        "public_id": "019d54f3-8242-77af-b23f-9088325853a5",
        "storage_key": "property/6767906449167334/019d54f3-8242-77af-b23f-9088325853a5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjWE2-jL39YgRsfqA9Ygf0yM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_9c310243-bcc9-4a29-903c-ad2d32da5c1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Downtown Gainesville",
      "poi_type": "Entertainment",
      "poi_address": "Spring St NE, Gainesville, GA 30501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f2-eb4d-77ea-a674-2d6e7fab3022.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a multi-story brick building with shops on the ground floor and apartments above.",
        "public_id": "019d54f2-eb4d-77ea-a674-2d6e7fab3022",
        "storage_key": "property/6767906449167334/019d54f2-eb4d-77ea-a674-2d6e7fab3022.webp",
        "width": 2746,
        "height": 2070
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4354571619051664033&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "downtown-gainesville",
      "poi_latitude": "34.2992757",
      "poi_longitude": "-83.8270022",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-533-5846",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f3-8245-765b-8e2e-91fd009f5edd",
        "storage_key": "property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOdl6SI329YgRoXKS5tCLbjw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_2b86e078-caad-4721-b92f-9a92f4393cdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Northeast Georgia History Center",
      "poi_type": "Entertainment",
      "poi_address": "322 Academy St NE, Gainesville, GA 30501, USA",
      "poi_short_description": "Museum featuring exhibits on regional culture & history, plus a shop with books & local crafts.",
      "poi_long_description": "Museum featuring exhibits on regional culture & history, plus a shop with books & local crafts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f2-ef27-765a-b4e1-2c84914c8df7.webp",
      "poi_featured_image_media": {
        "alt_text": "Rustic dining room with a stone fireplace and a table set for a meal.",
        "public_id": "019d54f2-ef27-765a-b4e1-2c84914c8df7",
        "storage_key": "property/6767906449167334/019d54f2-ef27-765a-b4e1-2c84914c8df7.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "http://www.negahc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7491700726147654901&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northeast-georgia-history-center",
      "poi_latitude": "34.3024578",
      "poi_longitude": "-83.82487890000002",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 770-297-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-823f-7333-83bd-42c6a002612a.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon with letter M inside",
        "public_id": "019d54f3-823f-7333-83bd-42c6a002612a",
        "storage_key": "property/6767906449167334/019d54f3-823f-7333-83bd-42c6a002612a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJB1ZmW_P29YgR9SSRIR7e92c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_5939892c-0db0-4686-9b4b-a91fc708310c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Flowery Branch Depot",
      "poi_type": "Entertainment",
      "poi_address": "5302 Railroad Ave, Flowery Branch, GA 30542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f2-f5d1-7714-9f72-6598688507eb.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of the historic \"Flower Branch\" building with a yellow facade and two brown doors.",
        "public_id": "019d54f2-f5d1-7714-9f72-6598688507eb",
        "storage_key": "property/6767906449167334/019d54f2-f5d1-7714-9f72-6598688507eb.webp",
        "width": 2880,
        "height": 2160
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12978180983265958640&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "flowery-branch-depot",
      "poi_latitude": "34.1847871",
      "poi_longitude": "-83.92544439999999",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-823f-7333-83bd-42c6a002612a.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon with letter M inside",
        "public_id": "019d54f3-823f-7333-83bd-42c6a002612a",
        "storage_key": "property/6767906449167334/019d54f3-823f-7333-83bd-42c6a002612a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2UrwJsjz9YgR8BpMytfCG7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_492c2e4c-023a-46cd-a6f3-1e2a29cc0dfe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1025 Dawsonville Hwy, Gainesville, GA 30501, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of quality equipment, tanning options, and massage chairs. They highlight the friendly, welcoming, and non-judgemental atmosphere, and the clean and well-maintained facilities. They also like the attentive and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-03bd-773c-890b-15575d41fb34.webp",
      "poi_featured_image_media": {
        "alt_text": "A busy gym with many people working out on various machines.",
        "public_id": "019d54f3-03bd-773c-890b-15575d41fb34",
        "storage_key": "property/6767906449167334/019d54f3-03bd-773c-890b-15575d41fb34.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/gainesville-ga?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=12885461475930022940&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "34.3001115",
      "poi_longitude": "-83.8596073",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 678-971-5558",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f3-8245-765b-8e2e-91fd009f5edd",
        "storage_key": "property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK-TqgJz29YgRHCTKN_Fa0rI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_20ae207e-12d7-4310-b3ac-924e0e73e42a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Crunch Fitness - Gainesville GA",
      "poi_type": "Health and Wellness",
      "poi_address": "250 John W Morrow Jr Pkwy, Gainesville, GA 30501, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment and classes, including hot yoga, pilates, HIIT, boxing, and Zumba. They highlight the spacious layout, clean facilities, and the availability of amenities like a sauna and massage chairs. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-01cc-7154-b750-14791d5a5d71.webp",
      "poi_featured_image_media": {
        "alt_text": "Woman squatting with barbell in gym.",
        "public_id": "019d54f3-01cc-7154-b750-14791d5a5d71",
        "storage_key": "property/6767906449167334/019d54f3-01cc-7154-b750-14791d5a5d71.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.crunch.com/locations/gainesville-ga",
      "poi_directions_map_url": "https://maps.google.com/?cid=7425028289548570017&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---gainesville-ga",
      "poi_latitude": "34.2955875",
      "poi_longitude": "-83.8390988",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 470-768-7280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f3-8245-765b-8e2e-91fd009f5edd",
        "storage_key": "property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL23XSyX39YgRoc3EzeP_Cmc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3091071f-ac22-4c46-a0eb-0277c83cd422",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Animal Emergency of Gainesville",
      "poi_type": "Health and Wellness",
      "poi_address": "275 Pearl Nix Pkwy # 3, Gainesville, GA 30501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-03cd-73fd-b8fb-61898a0b8430.webp",
      "poi_featured_image_media": {
        "alt_text": "Dog standing with a person's hands on its chest, possibly at a veterinary clinic.",
        "public_id": "019d54f3-03cd-73fd-b8fb-61898a0b8430",
        "storage_key": "property/6767906449167334/019d54f3-03cd-73fd-b8fb-61898a0b8430.webp",
        "width": 1728,
        "height": 3072
      },
      "poi_business_url": "https://animalergainesville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17069490896506426280&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "animal-emergency-of-gainesville",
      "poi_latitude": "34.2910666",
      "poi_longitude": "-83.84143250000001",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-534-2911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f3-8245-765b-8e2e-91fd009f5edd",
        "storage_key": "property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9Y1DN5n29YgRqJMHR4gD4-w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_c35dc723-8bda-4792-9239-35855b456a53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "The Beast Sports Center, LLC",
      "poi_type": "Health and Wellness",
      "poi_address": "206 College Ave SE, Gainesville, GA 30501, USA",
      "poi_short_description": "Relaxed gym with boxing-ring and weightlifting facilities, plus group classes.",
      "poi_long_description": "People say this gym offers a variety of equipment and classes, including boxing, powerlifting, and Zumba. They also highlight the motivating and supportive environment, and the friendly and helpful staff.\n\nOther reviews mention the equipment can be old.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-0d93-769c-a31a-787973f187c8.webp",
      "poi_featured_image_media": {
        "alt_text": "Gym with weight benches and dumbbells",
        "public_id": "019d54f3-0d93-769c-a31a-787973f187c8",
        "storage_key": "property/6767906449167334/019d54f3-0d93-769c-a31a-787973f187c8.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.thebeastsportscenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7546907901394317376&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-beast-sports-center-llc",
      "poi_latitude": "34.2957822",
      "poi_longitude": "-83.8222095",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-503-0930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f3-8245-765b-8e2e-91fd009f5edd",
        "storage_key": "property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcb0687_39YgRQHAyR8AAvGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_217a209b-3c1c-429b-8530-ddf32c29c54c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Burn Boot Camp",
      "poi_type": "Health and Wellness",
      "poi_address": "662 Dawsonville Hwy, Gainesville, GA 30501, USA",
      "poi_short_description": "Gym and boot camp featuring cardio and strength training, plus childcare.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-149d-7141-82a3-6d29a8df14be.webp",
      "poi_featured_image_media": {
        "alt_text": "People doing box jumps in a fitness class.",
        "public_id": "019d54f3-149d-7141-82a3-6d29a8df14be",
        "storage_key": "property/6767906449167334/019d54f3-149d-7141-82a3-6d29a8df14be.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "https://locations.burnbootcamp.com/locations/gainesville-ga/?utm_source=gmb&utm_medium=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=4061703933479180103&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "burn-boot-camp",
      "poi_latitude": "34.2967678",
      "poi_longitude": "-83.8531421",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 470-892-5094",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f3-8245-765b-8e2e-91fd009f5edd",
        "storage_key": "property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvRoYlE319YgRR1fVKTUSXjg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1de115d6-a440-43d5-88f6-ec5073c5be77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "High Definition Studio & Barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "675 E E Butler Pkwy, Gainesville, GA 30501, USA",
      "poi_short_description": "Haircuts, shave services and beard trims in a relaxed space with friendly staff and a welcoming atmosphere.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-0eb0-7791-b7c0-f8438e51c127.webp",
      "poi_featured_image_media": {
        "alt_text": "Hair salon interior with rows of barber chairs covered in capes.",
        "public_id": "019d54f3-0eb0-7791-b7c0-f8438e51c127",
        "storage_key": "property/6767906449167334/019d54f3-0eb0-7791-b7c0-f8438e51c127.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.hdstudioshop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1523101616199193867&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "high-definition-studio--barbershop",
      "poi_latitude": "34.2964302",
      "poi_longitude": "-83.8184493",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 470-290-8141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f3-8245-765b-8e2e-91fd009f5edd",
        "storage_key": "property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2YfCM-729YgRC1VgptkkIxU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_7f454865-3e51-4741-9f8a-1c82848363b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4029 Winder Hwy, Flowery Branch, GA 30542, USA",
      "poi_short_description": "Chain fitness center open 24/7 featuring a weightlifting area, group workouts, and personal training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-1518-7558-8d36-8a1a0fbb18a0.webp",
      "poi_featured_image_media": {
        "alt_text": "Fitness center with cardio machines and weight training equipment",
        "public_id": "019d54f3-1518-7558-8d36-8a1a0fbb18a0",
        "storage_key": "property/6767906449167334/019d54f3-1518-7558-8d36-8a1a0fbb18a0.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/flowery-branch-georgia-2061/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=2061",
      "poi_directions_map_url": "https://maps.google.com/?cid=9014453615560453540&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "34.1962064",
      "poi_longitude": "-83.8572107",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 678-450-1120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f3-8245-765b-8e2e-91fd009f5edd",
        "storage_key": "property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj93D3Bny9YgRpG23f83FGX0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_73c1477b-1e7c-47ff-85f7-5722bc067763",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Animal Medical Care",
      "poi_type": "Health and Wellness",
      "poi_address": "984 Thompson Bridge Rd, Gainesville, GA 30501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-0e5a-746e-a1f2-b91083e7ce18.webp",
      "poi_featured_image_media": {
        "alt_text": "Veterinarian examining a dog.",
        "public_id": "019d54f3-0e5a-746e-a1f2-b91083e7ce18",
        "storage_key": "property/6767906449167334/019d54f3-0e5a-746e-a1f2-b91083e7ce18.webp",
        "width": 870,
        "height": 300
      },
      "poi_business_url": "https://vetamc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8384040241879818839&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "animal-medical-care",
      "poi_latitude": "34.314023",
      "poi_longitude": "-83.82832680000001",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 770-532-1217",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f3-8245-765b-8e2e-91fd009f5edd",
        "storage_key": "property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP2sc12D29YgRV6LT7y0YWnQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_05d49ddd-644a-4b05-a8a8-f4f6de9668d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Gainesville Veterinary Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1363 Thompson Bridge Rd, Gainesville, GA 30501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-1c6a-739b-9f81-dfdfd04f6fd2.webp",
      "poi_featured_image_media": {
        "alt_text": "Gainesville Veterinary Hospital sign",
        "public_id": "019d54f3-1c6a-739b-9f81-dfdfd04f6fd2",
        "storage_key": "property/6767906449167334/019d54f3-1c6a-739b-9f81-dfdfd04f6fd2.webp",
        "width": 1080,
        "height": 850
      },
      "poi_business_url": "https://gvhvet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=934284202106240662&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gainesville-veterinary-hospital",
      "poi_latitude": "34.3198838",
      "poi_longitude": "-83.8327513",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 770-670-7645",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f3-8245-765b-8e2e-91fd009f5edd",
        "storage_key": "property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsaF-i2X29YgRlj7NIYg-9ww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_471d9ba7-7c52-4ab4-9816-b35134d1375d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "MV 2 Nails & Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "1943 Jesse Jewell Pkwy SE, Gainesville, GA 30501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-1f42-728d-92f8-ab4965804ed3.webp",
      "poi_featured_image_media": {
        "alt_text": "Advertisement for hiring a licensed nail technician for MV 2 Nails & Spa.",
        "public_id": "019d54f3-1f42-728d-92f8-ab4965804ed3",
        "storage_key": "property/6767906449167334/019d54f3-1f42-728d-92f8-ab4965804ed3.webp",
        "width": 1320,
        "height": 1981
      },
      "poi_business_url": "https://mv2nailsandspa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11319927804711695808&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mv-2-nails--spa",
      "poi_latitude": "34.3153945",
      "poi_longitude": "-83.7972376",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 678-943-1224",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f3-8245-765b-8e2e-91fd009f5edd",
        "storage_key": "property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXUWiUQD39YgRwHXo4lx2GJ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_5f38f83e-25e3-445c-92b0-5100ce80646c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Northeast Georgia Medical Center Gainesville",
      "poi_type": "Health and Wellness",
      "poi_address": "743 Spring St NE, Gainesville, GA 30501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-2c70-7339-a10b-7586254e1551.webp",
      "poi_featured_image_media": {
        "alt_text": "Northeast Georgia Medical Center building exterior with a clear blue sky.",
        "public_id": "019d54f3-2c70-7339-a10b-7586254e1551",
        "storage_key": "property/6767906449167334/019d54f3-2c70-7339-a10b-7586254e1551.webp",
        "width": 3072,
        "height": 2050
      },
      "poi_business_url": "https://www.nghs.com/locations/gainesville",
      "poi_directions_map_url": "https://maps.google.com/?cid=3559900896547898260&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northeast-georgia-medical-center-gainesville",
      "poi_latitude": "34.3041926",
      "poi_longitude": "-83.8168211",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 770-219-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-825c-70a3-bd92-af9dcea1d076.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019d54f3-825c-70a3-bd92-af9dcea1d076",
        "storage_key": "property/6767906449167334/019d54f3-825c-70a3-bd92-af9dcea1d076.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJu425Mff29YgRlANVFgFPZzE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a8d1d484-c227-4372-b450-da2e26419ca0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Gainesville Primary Care | Windermere Medical Group",
      "poi_type": "Health and Wellness",
      "poi_address": "1556 & 1564, Park Hill Dr, Gainesville, GA 30501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-2c60-73c2-bd74-ae41c82bfa95.webp",
      "poi_featured_image_media": {
        "alt_text": "Windermere Medical Group reception area with coffee station and promotional banner.",
        "public_id": "019d54f3-2c60-73c2-bd74-ae41c82bfa95",
        "storage_key": "property/6767906449167334/019d54f3-2c60-73c2-bd74-ae41c82bfa95.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://windermeremedical.com/gainesville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7577176124359672994&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gainesville-primary-care--windermere-medical-group",
      "poi_latitude": "34.3235749",
      "poi_longitude": "-83.8161215",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 678-400-7001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-825c-70a3-bd92-af9dcea1d076.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019d54f3-825c-70a3-bd92-af9dcea1d076",
        "storage_key": "property/6767906449167334/019d54f3-825c-70a3-bd92-af9dcea1d076.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJexI77y_39YgRooQHHYqJJ2k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_d6494ec6-45a9-4123-afe5-e166a4746452",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Chicopee Woods Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2515 Atlanta Hwy, Gainesville, GA 30504, USA",
      "poi_short_description": "Public golf course featuring 3 nine-hole layouts, a practice facility, and scenic views.",
      "poi_long_description": "People say this golf course offers well-maintained greens, fairways, and a driving range, and has a good 27-hole layout. They also highlight the reasonable green fees, excellent practice facility, and the friendly and accommodating staff.\n\nOther reviews mention the pace of play can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-2a86-752b-b322-bcaa9303c336.webp",
      "poi_featured_image_media": {
        "alt_text": "Chicopee Wood Golf Course with lake and trees",
        "public_id": "019d54f3-2a86-752b-b322-bcaa9303c336",
        "storage_key": "property/6767906449167334/019d54f3-2a86-752b-b322-bcaa9303c336.webp",
        "width": 2048,
        "height": 1229
      },
      "poi_business_url": "http://www.chicopeewoodsgolfcourse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8781930352245619260&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chicopee-woods-golf-course",
      "poi_latitude": "34.2417769",
      "poi_longitude": "-83.8499027",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 770-534-7322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-825b-75aa-b564-f15af838a7af.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon representing a person playing soccer",
        "public_id": "019d54f3-825b-75aa-b564-f15af838a7af",
        "storage_key": "property/6767906449167334/019d54f3-825b-75aa-b564-f15af838a7af.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJZd9_Tt7z9YgRPDrSbyCv33k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_ecc3e0b9-2d0c-4772-bf3d-2f151ff1d683",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Lanier Point Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1579 Lee Waldrip Dr, Gainesville, GA 30501, USA",
      "poi_short_description": "Sports facility featuring baseball & softball fields, plus nearby hiking trails with lake views.",
      "poi_long_description": "People say this park offers baseball fields, fishing spots, and walking trails. They highlight the clean and well-maintained grounds, and the picturesque views of the lake and sunset. They also like the family-friendly atmosphere with picnic tables and grilling areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-2cdc-7709-a6cd-3cc8b8c28b13.webp",
      "poi_featured_image_media": {
        "alt_text": "Covered wooden bridge over a body of water, surrounded by trees and nature.",
        "public_id": "019d54f3-2cdc-7709-a6cd-3cc8b8c28b13",
        "storage_key": "property/6767906449167334/019d54f3-2cdc-7709-a6cd-3cc8b8c28b13.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.gainesville.org/Facilities/Facility/Details/Lanier-Point-Park-and-Athletic-Complex-21",
      "poi_directions_map_url": "https://maps.google.com/?cid=8985036357768052275&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lanier-point-park",
      "poi_latitude": "34.2990922",
      "poi_longitude": "-83.8680517",
      "poi_miles_from_property": "17.9",
      "poi_walking_minutes": "6 hours 36 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 770-287-0208",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8539-72e9-9373-0e56b2341a16.webp",
      "poi_map_icon_media": {
        "alt_text": "Simple black icon of a Christmas tree.",
        "public_id": "019d54f3-8539-72e9-9373-0e56b2341a16",
        "storage_key": "property/6767906449167334/019d54f3-8539-72e9-9373-0e56b2341a16.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIS2g1qj39YgRM_67bvZCsXw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6bf05de5-88b3-42f1-853e-1a5f4e2d0139",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Alberta Banks Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5575 GC Crow Rd #2704, Flowery Branch, GA 30542, USA",
      "poi_short_description": "Relaxed local park featuring baseball fields, tennis courts, playgrounds and a pavilion.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-37c5-73a0-82e8-4410a9d32ba7.webp",
      "poi_featured_image_media": {
        "alt_text": "Colorful playground structure with slides and climbing elements.",
        "public_id": "019d54f3-37c5-73a0-82e8-4410a9d32ba7",
        "storage_key": "property/6767906449167334/019d54f3-37c5-73a0-82e8-4410a9d32ba7.webp",
        "width": 2313,
        "height": 3072
      },
      "poi_business_url": "http://www.hallcounty.org/facilities/facility/details/Alberta-Banks-Park-1",
      "poi_directions_map_url": "https://maps.google.com/?cid=14180124399325190148&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "alberta-banks-park",
      "poi_latitude": "34.2014847",
      "poi_longitude": "-83.9260732",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-535-8280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8539-72e9-9373-0e56b2341a16.webp",
      "poi_map_icon_media": {
        "alt_text": "Simple black icon of a Christmas tree.",
        "public_id": "019d54f3-8539-72e9-9373-0e56b2341a16",
        "storage_key": "property/6767906449167334/019d54f3-8539-72e9-9373-0e56b2341a16.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ1VbSLby9YgRBJig_ALsycQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6aa8779c-9af9-4130-a4f5-d25285e8d24e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "River Forks Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3500 Keith Bridge Rd, Gainesville, GA 30504, USA",
      "poi_short_description": "A 118-acre beach preserve on the shores of Lake Lanier offering tent & RV campgrounds & a boat ramp.",
      "poi_long_description": "People say this park offers beautiful lake views, a boat ramp, and access to water for various activities. They also highlight the peaceful and quiet atmosphere, the friendly and helpful staff, and the clean facilities.\n\nOther reviews mention the campsites can be close together.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-463f-70db-b907-0bcbdc4fe889.webp",
      "poi_featured_image_media": {
        "alt_text": "Lake with trees on the shore and a clear blue sky.",
        "public_id": "019d54f3-463f-70db-b907-0bcbdc4fe889",
        "storage_key": "property/6767906449167334/019d54f3-463f-70db-b907-0bcbdc4fe889.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.hallcounty.org/Facilities/Facility/Details/River-Forks-Park-11",
      "poi_directions_map_url": "https://maps.google.com/?cid=14681958507439980283&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "river-forks-park",
      "poi_latitude": "34.2889475",
      "poi_longitude": "-83.90498910000001",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-531-3952",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8539-72e9-9373-0e56b2341a16.webp",
      "poi_map_icon_media": {
        "alt_text": "Simple black icon of a Christmas tree.",
        "public_id": "019d54f3-8539-72e9-9373-0e56b2341a16",
        "storage_key": "property/6767906449167334/019d54f3-8539-72e9-9373-0e56b2341a16.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJT-ANEpL09YgR-_77YnnLwMs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_eaed31ec-a8f5-46b8-8214-502b4bdc75d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Gainesville Square",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "112 Bradford St NE, Gainesville, GA 30501, USA",
      "poi_short_description": "Public space with benches, shops, restaurants, a monument, and space for walking, concerts, and events.",
      "poi_long_description": "People say this park is a charming spot to relax, enjoy a bag lunch, or sip coffee from a nearby shop, surrounded by beautiful trees and historic architecture. They also highlight the lively and welcoming atmosphere, with frequent community events, a variety of restaurants, and unique boutiques.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-570a-74fc-8f6c-52823b831bba.webp",
      "poi_featured_image_media": {
        "alt_text": "Confederate soldier statue on a marble monument.",
        "public_id": "019d54f3-570a-74fc-8f6c-52823b831bba",
        "storage_key": "property/6767906449167334/019d54f3-570a-74fc-8f6c-52823b831bba.webp",
        "width": 1728,
        "height": 3072
      },
      "poi_business_url": "http://gainesville.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12959398934197671847&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gainesville-square",
      "poi_latitude": "34.2993989",
      "poi_longitude": "-83.8269486",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 770-533-5846",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8539-72e9-9373-0e56b2341a16.webp",
      "poi_map_icon_media": {
        "alt_text": "Simple black icon of a Christmas tree.",
        "public_id": "019d54f3-8539-72e9-9373-0e56b2341a16",
        "storage_key": "property/6767906449167334/019d54f3-8539-72e9-9373-0e56b2341a16.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcwgDOY329YgRp5dtN6sI2bM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_05aa3a04-d18a-49ef-8eb5-9b500e5bbb51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Lee Gilmer Memorial Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1137 Aviation Way, Gainesville, GA 30501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-3b41-726d-bfc9-ba0efe3266c2.webp",
      "poi_featured_image_media": {
        "alt_text": "Two small airplanes in a hangar, one above the other. The lower airplane has \"FOR SALE\" flags on its propeller.",
        "public_id": "019d54f3-3b41-726d-bfc9-ba0efe3266c2",
        "storage_key": "property/6767906449167334/019d54f3-3b41-726d-bfc9-ba0efe3266c2.webp",
        "width": 1728,
        "height": 3072
      },
      "poi_business_url": "http://www.gainesville.org/lee-gilmer-memorial-airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=4334241321544088706&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lee-gilmer-memorial-airport",
      "poi_latitude": "34.2736671",
      "poi_longitude": "-83.8315121",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-532-4136",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8668-768c-b4d2-913b0668ab0d.webp",
      "poi_map_icon_media": {
        "alt_text": "Airplane icon",
        "public_id": "019d54f3-8668-768c-b4d2-913b0668ab0d",
        "storage_key": "property/6767906449167334/019d54f3-8668-768c-b4d2-913b0668ab0d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJTzGQRY729YgRgnx0pYRRJjw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_145c9f22-e98f-407f-bff8-94430a85b81b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Gainesville",
      "poi_type": "Transportation & Transit",
      "poi_address": "116 Industrial Blvd, Gainesville, GA 30501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-5715-765f-b888-a40b705c8ef6.webp",
      "poi_featured_image_media": {
        "alt_text": "Norfolk Southern train with number 6313 in front.",
        "public_id": "019d54f3-5715-765f-b888-a40b705c8ef6",
        "storage_key": "property/6767906449167334/019d54f3-5715-765f-b888-a40b705c8ef6.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=GNS",
      "poi_directions_map_url": "https://maps.google.com/?cid=16380576991303314299&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gainesville",
      "poi_latitude": "34.2887701",
      "poi_longitude": "-83.81962039999999",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-866b-756e-a5f6-22dbd0ea8046.webp",
      "poi_map_icon_media": {
        "alt_text": "Train icon",
        "public_id": "019d54f3-866b-756e-a5f6-22dbd0ea8046",
        "storage_key": "property/6767906449167334/019d54f3-866b-756e-a5f6-22dbd0ea8046.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJvzdeCun29YgReyuSTvx_U-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_a8ea38d7-a7bb-4db9-95dc-3d7c6d84eb11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Champion Aviation Services Inc",
      "poi_type": "Transportation & Transit",
      "poi_address": "3-1 Aviation Way, Gainesville, GA 30501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-47ba-7351-9cc4-ad9f33505b27.webp",
      "poi_featured_image_media": {
        "alt_text": "Lounge area with plush seating, unique coffee table, and large windows with a scenic view.",
        "public_id": "019d54f3-47ba-7351-9cc4-ad9f33505b27",
        "storage_key": "property/6767906449167334/019d54f3-47ba-7351-9cc4-ad9f33505b27.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.flychampion.com/pages/main.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=12952940314372604772&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "champion-aviation-services-inc",
      "poi_latitude": "34.2752938",
      "poi_longitude": "-83.83195429999999",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-532-4136",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8668-768c-b4d2-913b0668ab0d.webp",
      "poi_map_icon_media": {
        "alt_text": "Airplane icon",
        "public_id": "019d54f3-8668-768c-b4d2-913b0668ab0d",
        "storage_key": "property/6767906449167334/019d54f3-8668-768c-b4d2-913b0668ab0d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJwdvaBrr29YgRZAMEm5YWwrM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_6603374c-80b2-4e2d-b3a0-3630ce7c53a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Fox Factory",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2315 W Park Dr, Gainesville, GA 30504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-5696-779f-8a23-db3b7f10ad86.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a large warehouse building with a blue semi-truck at a loading dock.",
        "public_id": "019d54f3-5696-779f-8a23-db3b7f10ad86",
        "storage_key": "property/6767906449167334/019d54f3-5696-779f-8a23-db3b7f10ad86.webp",
        "width": 3072,
        "height": 1382
      },
      "poi_business_url": "http://www.ridefox.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11576193638620845495&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fox-factory",
      "poi_latitude": "34.2444678",
      "poi_longitude": "-83.8527105",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 800-369-7469",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f3-8245-765b-8e2e-91fd009f5edd",
        "storage_key": "property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq5qFkJfz9YgRt9Uh8cfmpqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_097c8e22-b6bd-4811-88d6-757dcbb0ad46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Tag Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2875 Browns Bridge Rd, Gainesville, GA 30504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-6a98-753f-af35-3c349d852c6d.webp",
      "poi_featured_image_media": {
        "alt_text": "Concrete walkway leading to a modern building surrounded by green grass and trees under a blue sky with clouds.",
        "public_id": "019d54f3-6a98-753f-af35-3c349d852c6d",
        "storage_key": "property/6767906449167334/019d54f3-6a98-753f-af35-3c349d852c6d.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.hallcounty.org/QuickLinks.aspx?CID=58",
      "poi_directions_map_url": "https://maps.google.com/?cid=15860208419284917093&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tag-office",
      "poi_latitude": "34.2776145",
      "poi_longitude": "-83.8769236",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-531-6950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f3-8245-765b-8e2e-91fd009f5edd",
        "storage_key": "property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4SdJLnD09YgRZRsjv4bHGtw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_29b24e07-7334-4921-b977-9f75e328400d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Tribe Express Truck Shop",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3721 Old Oakwood Rd, Oakwood, GA 30566, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7120519457922950165&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tribe-express-truck-shop",
      "poi_latitude": "34.2329484",
      "poi_longitude": "-83.8808261",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f3-8245-765b-8e2e-91fd009f5edd",
        "storage_key": "property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1-ym2Irz9YgRFSTBibgq0WI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a53a15d2-550e-4132-8ec7-0fc3f2e1650e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Oakwood City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4035 Walnut St, Oakwood, GA 30566, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-711d-7354-9682-2cb2c57a1800.webp",
      "poi_featured_image_media": {
        "alt_text": "Building exterior of the community hall with a clock tower.",
        "public_id": "019d54f3-711d-7354-9682-2cb2c57a1800",
        "storage_key": "property/6767906449167334/019d54f3-711d-7354-9682-2cb2c57a1800.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.cityofoakwood.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15229170730925870690&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oakwood-city-hall",
      "poi_latitude": "34.2287904",
      "poi_longitude": "-83.88236669999999",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 770-534-2365",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-866d-748a-8248-3e80f3dddb3f.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon.",
        "public_id": "019d54f3-866d-748a-8248-3e80f3dddb3f",
        "storage_key": "property/6767906449167334/019d54f3-866d-748a-8248-3e80f3dddb3f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmws0hq7z9YgRYs6cmBfiWNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_2798dbc6-e54a-4775-a11e-1cd98369205a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "poi_name": "Lawson Air Conditioning & Plumbing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "865 Dorsey St, Gainesville, GA 30501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-6568-773b-8d54-243c00bf520e.webp",
      "poi_featured_image_media": {
        "alt_text": "Lawson Air Conditioning and Plumbing company vans parked outside.",
        "public_id": "019d54f3-6568-773b-8d54-243c00bf520e",
        "storage_key": "property/6767906449167334/019d54f3-6568-773b-8d54-243c00bf520e.webp",
        "width": 2048,
        "height": 1367
      },
      "poi_business_url": "http://www.lawsonac.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17622194245441325755&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lawson-air-conditioning--plumbing",
      "poi_latitude": "34.2835605",
      "poi_longitude": "-83.8316246",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-536-2301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f3-8245-765b-8e2e-91fd009f5edd",
        "storage_key": "property/6767906449167334/019d54f3-8245-765b-8e2e-91fd009f5edd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbYGZKLz29YgRu4p2wkycjvQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_d2588f03-02ac-4eed-8715-dbecb1983112",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_9c151957-0e62-4639-8764-0c610c77c220",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_9152c7af-d952-4fc8-97e8-b8887afee2ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_9daade64-9564-49d4-9dbb-8aff7b21d1c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_a23f71b2-18b6-4ff9-b6f3-e434a0177f1e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_84f06f59-567f-41c5-b878-e59bc3fa0580",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_95a8cab6-514c-439c-a3d2-146684f0a931",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "rating": "5.0",
      "name": "Andrea Nieto",
      "text": "I went to check this place for my best friend.. I absolutely love it!\nThe property is well maintained, peaceful, and feels like home.\nI especially want to highlight Tonya—she was absolutely amazing. She was professional, friendly, and always willing to help, making the entire process smooth and stress-free. Her customer service really makes a difference.\nI highly recommend this community to anyone looking for a great place to live with outstanding staff!",
      "date": "2025-12-17",
      "title": ""
    },
    {
      "id": "custom_2c906f63-b522-4ded-95b9-99fbdbadc653",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "rating": "5.0",
      "name": "Cassandra Sanders",
      "text": "Today I stopped by the leasing office to tour the community and was greeted by Ms. Tonya. She was such a pleasant to talk with, she was very professional and took the time explaining everything clearly, answering all my questions. The apartments and the community were really nice, very well maintained with great amenities. I highly recommend this community.",
      "date": "2025-11-01",
      "title": ""
    },
    {
      "id": "custom_e427934d-681e-4381-aaf2-5f3cabe43199",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "rating": "5.0",
      "name": "Bijan Afrazi",
      "text": "Just wanted to write a review and say Easton is very quick and prompt at maintenance and repairs. I’ve had issues with some of the appliances and he is very assuring and friendly! He made sure to put me at ease with coming same day to fix the repairs. Even willing to come in during a Friday request to have it fixed before the weekend. Really great guy and his customer service is top notch!",
      "date": "2025-09-05",
      "title": ""
    },
    {
      "id": "custom_74930c60-4b68-44b6-a2ad-ceb834f408bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "rating": "4.0",
      "name": "Nathalia",
      "text": "Although it was a bit of a rocky road to get through as a college student, I would really thank Tonya for making it feel a lot faster and easier than it would’ve been. Super kind and considerate person and made all the information very clear from the start, making it a smooth transition. I would definitely recommend Tonya!",
      "date": "2026-07-09",
      "title": ""
    },
    {
      "id": "custom_0bc54467-cc28-42ef-b12a-f310956ad633",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "rating": "5.0",
      "name": "Krazy Ate (krazyate)",
      "text": "Mrs. Tonya was extremely helpful throughout the entire process. she made application and move-in seamless and stress free. 10/10 no notes",
      "date": "2026-07-18",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_3cd8d7d0ba23776136765b38",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "false",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/PszxRieVQtb?source=180"
    },
    {
      "id": "ec_9daa6def088dfd447bc06d43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "false",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/9l4c8k?source=180"
    },
    {
      "id": "ec_17c8159b047ccd8145d5c705",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "false",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/qXQFdBZdGpg?source=180"
    },
    {
      "id": "ec_a6e1a1696069d78a53b29d2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d620a-11b6-771e-a321-448c1987e48f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d620a-11b6-771e-a321-448c1987e48f",
        "storage_key": "property/6767906449167334/019d620a-11b6-771e-a321-448c1987e48f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Business Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=zhEXp3TvJ2C"
    },
    {
      "id": "ec_6549e8bef35b596714cc831a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d620a-11b4-771e-91a8-ad6b5a2adfbd.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d620a-11b4-771e-91a8-ad6b5a2adfbd",
        "storage_key": "property/6767906449167334/019d620a-11b4-771e-91a8-ad6b5a2adfbd.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3BR, 3BA - 1208SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=nnuHcyvPDQs"
    },
    {
      "id": "ec_41af13e49b7a9f6a678c1ba8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d620a-111e-7166-ae90-00ce09f151c3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d620a-111e-7166-ae90-00ce09f151c3",
        "storage_key": "property/6767906449167334/019d620a-111e-7166-ae90-00ce09f151c3.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3BR, 3BA - 1208SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=hnBVVFoQSu3"
    },
    {
      "id": "ec_d8b5edb652696734d0eeffc2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d620a-11b9-760a-bfe6-f27366d5156b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d620a-11b9-760a-bfe6-f27366d5156b",
        "storage_key": "property/6767906449167334/019d620a-11b9-760a-bfe6-f27366d5156b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=DHkoSdHeQpM"
    },
    {
      "id": "ec_6c5186d9c9a471d41accc6f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d620a-1232-7669-83d8-5a3101de6373.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d620a-1232-7669-83d8-5a3101de6373",
        "storage_key": "property/6767906449167334/019d620a-1232-7669-83d8-5a3101de6373.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Business Center / Study Lounge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=vuJrB8QTiGs"
    },
    {
      "id": "ec_808ae62ad7efd176d17018a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/01a1253d-95bc-739d-9bd0-3bdefa5dc99f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a1253d-95bc-739d-9bd0-3bdefa5dc99f",
        "storage_key": "property/6767906449167334/01a1253d-95bc-739d-9bd0-3bdefa5dc99f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pool",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=66PSnX4vqTF"
    },
    {
      "id": "ec_964e7e13287dcb9a693e0831",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/01a1253d-9e81-75ed-ad36-23dceb846cf3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a1253d-9e81-75ed-ad36-23dceb846cf3",
        "storage_key": "property/6767906449167334/01a1253d-9e81-75ed-ad36-23dceb846cf3.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3BR, 3BA - 1,256SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=mrpqVmuJNmF"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db23f-cd63-72e2-bd0f-7fa1d9362f01",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "The Deryn Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334"
    },
    {
      "lead_collector_id": "019db23f-cdd6-73e9-9070-cd63a2215899",
      "lead_source": "FACEBOOK_ADS",
      "name": "The Deryn Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334"
    },
    {
      "lead_collector_id": "019db23f-ce45-70af-a075-3acbccfdf097",
      "lead_source": "LANDING_PAGE",
      "name": "The Deryn Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-gainesville-ga",
      "search_query": "pet friendly apartments gainesville ga",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Gainesville, GA",
      "h2_subtitle": "Discover pet-friendly living at The Deryn. Located in Gainesville, GA, enjoy great amenities and comfort for you and your furry friends.",
      "page_copy": "The Deryn offers pet-friendly apartments in Gainesville, GA with a variety of floor plans and community amenities. The property is located near local parks, walking trails, shopping, dining, and entertainment options throughout the Gainesville area.\n\nResidents have access to amenities including a fitness center with free weights, a swimming pool, and a poolside grilling area. Cable and internet service are included. The community also offers convenient access to major roadways, employers, and everyday services throughout Gainesville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with swimming pool and lounge chairs.",
        "public_id": "019d54f3-6513-704e-8300-7f52b8d04ec9",
        "storage_key": "property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Gainesville, GA",
      "seo_description": "The Deryn offers pet-friendly apartments in Gainesville, GA with included cable and internet, community amenities, and convenient access to local parks.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "page_item_url": "apartments-with-swimming-pool-hall-county",
      "search_query": "apartments with swimming pool hall county",
      "category": "Amenity",
      "h1_title": "Apartments with Swimming Pool in Hall County",
      "h2_subtitle": "Enjoy luxurious living at The Deryn with a refreshing swimming pool. Located in Hall County, we offer top amenities for comfort and relaxation.",
      "page_copy": "The Deryn offers apartments with a swimming pool in Hall County, along with a variety of community amenities. Residents have access to a swimming pool, poolside grilling area, fitness center with free weights, and vending options.\nCable and internet service are included. The community is also located near shopping, dining, entertainment, and major roadways throughout the Gainesville area, providing convenient access to local destinations and everyday services.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with swimming pool and lounge chairs.",
        "public_id": "019d54f3-6513-704e-8300-7f52b8d04ec9",
        "storage_key": "property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Swimming Pool in Hall County",
      "seo_description": "Discover The Deryn's apartments with a pool in Hall County. Enjoy top-notch amenities including a fitness center, cable, and internet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "page_item_url": "fitness-center-apartments-near-ung-gainesville",
      "search_query": "fitness center apartments near UNG gainesville",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments Near UNG Gainesville",
      "h2_subtitle": "Apartments Near UNG Gainesville with Fitness Center in Hall County",
      "page_copy": "The Deryn offers apartments near the University of North Georgia Gainesville Campus in Hall County with access to a fitness center and a range of community amenities.\nResidents have access to a fitness center with free weights and cardio equipment, a swimming pool, and a poolside grilling area. Cable and internet service are included. The community is also located near shopping, dining, entertainment, and major roadways throughout Gainesville, providing access to everyday conveniences and local destinations.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with swimming pool and lounge chairs.",
        "public_id": "019d54f3-6513-704e-8300-7f52b8d04ec9",
        "storage_key": "property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments Near UNG Gainesville",
      "seo_description": "The Deryn offers apartments near UNG Gainesville with a fitness center, swimming pool, grilling area, and included cable and internet in Gainesville, GA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "page_item_url": "in-unit-washer-dryer-gainesville-ga",
      "search_query": "in unit washer and dryer gainesville ga",
      "category": "Amenity",
      "h1_title": "In Unit Washer and Dryer in Gainesville, GA",
      "h2_subtitle": "Discover the convenience of in-unit washer and dryer appliances at The Deryn. Located in Gainesville, GA, our apartments offer unparalleled modern living.",
      "page_copy": "The Deryn in Gainesville, GA offers apartments with in-unit washer and dryer, providing on-site laundry access within the home. This feature is included alongside other community amenities designed for everyday living.\nResidents have access to a swimming pool, fitness center with free weights, and a poolside grilling area. Cable and internet service are included. The community is also located near shopping, dining, entertainment, and major roadways throughout Gainesville, providing convenient access to local services and destinations.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with swimming pool and lounge chairs.",
        "public_id": "019d54f3-6513-704e-8300-7f52b8d04ec9",
        "storage_key": "property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In Unit Washer and Dryer in Gainesville, GA",
      "seo_description": "Enjoy the ease of in-unit laundry at The Deryn in Gainesville, GA. With a pool and fitness center, live comfortably with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "page_item_url": "air-conditioned-student-apartments-gainesville-ga",
      "search_query": "air conditioned student apartments gainesville ga",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Gainesville, GA",
      "h2_subtitle": "Apartments in Gainesville, GA with Air Conditioning at The Deryn",
      "page_copy": "The Deryn offers apartments in Gainesville, GA with air conditioning and a range of community amenities. Homes include features designed for everyday living and convenient access to nearby services and destinations throughout Hall County.\nResidents have access to a swimming pool, fitness center with free weights, and a poolside grilling area. Cable and internet service are included. The community is also located near shopping, dining, entertainment, and major roadways throughout Gainesville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with swimming pool and lounge chairs.",
        "public_id": "019d54f3-6513-704e-8300-7f52b8d04ec9",
        "storage_key": "property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Gainesville, GA",
      "seo_description": "The Deryn offers apartments in Gainesville, GA with air conditioning, plus a swimming pool, fitness center, grilling area, and included cable and internet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-gainesville-ga",
      "search_query": "one bedroom apartments Gainesville GA",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Gainesville, GA",
      "h2_subtitle": "Explore one bedroom apartments at The Deryn in Gainesville, GA. Enjoy modern amenities and an ideal location near essential attractions.",
      "page_copy": "Discover the perfect balance of comfort and convenience at The Deryn, offering spacious one bedroom apartments in Gainesville, GA. Each unit is thoughtfully designed with modern features, providing a cozy and inviting home environment for singles or couples wanting their own private retreat.\n\nResidents appreciate our fantastic amenities, including a fitness center with free weights and a sparkling swimming pool, perfect for unwinding. Poolside grilling areas add a social element to leisure time, while the included cable and internet services ensure staying connected is easy. The Deryn is well-suited for those seeking a well-rounded living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with swimming pool and lounge chairs.",
        "public_id": "019d54f3-6513-704e-8300-7f52b8d04ec9",
        "storage_key": "property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Gainesville, GA",
      "seo_description": "Find your new home at The Deryn with one bedroom apartments in Gainesville, GA. Featuring modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-hall-county",
      "search_query": "three bedroom apartments Hall County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Hall County",
      "h2_subtitle": "Three-Bedroom Apartments at The Deryn in Hall Countys",
      "page_copy": "The Deryn offers three-bedroom apartment homes in Hall County with spacious floor plans and features designed for everyday living. The community provides convenient access to nearby shopping, dining, entertainment, and major roadways throughout the Gainesville area.\nResidents have access to amenities including a fitness center with free weights, a swimming pool, and a poolside grilling area. Cable and internet service are included. The community is also located near local parks and everyday conveniences throughout Hall County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with swimming pool and lounge chairs.",
        "public_id": "019d54f3-6513-704e-8300-7f52b8d04ec9",
        "storage_key": "property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Hall County",
      "seo_description": "The Deryn offers 3-bedroom apartments in Hall County with spacious floor plans, a fitness center, swimming pool, grilling area, and included cable and internet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "page_item_url": "apartments-near-ung-gainesville-campus",
      "search_query": "apartments near University of North Georgia Gainesville Campus",
      "category": "School",
      "h1_title": "Apartments Near University of North Georgia",
      "h2_subtitle": "Apartments Near the University of North Georgia Gainesville Campus",
      "page_copy": "The Deryn offers apartments near the University of North Georgia Gainesville Campus in Gainesville, GA. The community provides convenient access to educational institutions, local businesses, and surrounding destinations throughout Hall County.\nResidents have access to amenities including a fitness center with free weights, a swimming pool, and a poolside grilling area. Cable and internet service are included. The community is also located near shopping, dining, entertainment, and major roadways throughout the Gainesville area, providing access to everyday conveniences and local attractions.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with swimming pool and lounge chairs.",
        "public_id": "019d54f3-6513-704e-8300-7f52b8d04ec9",
        "storage_key": "property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of North Georgia",
      "seo_description": "The Deryn offers apartments near the University of North Georgia Gainesville Campus with cable and internet included, plus community amenities in Gainesville.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "page_item_url": "apartments-close-to-brenau-university-hall-county",
      "search_query": "apartments close to Brenau University in Hall County",
      "category": "School",
      "h1_title": "Apartments Near Brenau University, Hall County",
      "h2_subtitle": "Apartments Near Brenau University in Gainesville, GA",
      "page_copy": "The Deryn offers apartments near Brenau University in Hall County. The community provides convenient access to educational institutions, local businesses, and surrounding destinations throughout the Gainesville area.\nResidents have access to a fitness center with free weights, a swimming pool, and a poolside grilling area. Cable and internet service are included. The community is also located near shopping, dining, entertainment, and major roadways throughout Gainesville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with swimming pool and lounge chairs.",
        "public_id": "019d54f3-6513-704e-8300-7f52b8d04ec9",
        "storage_key": "property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Brenau University, Hall County",
      "seo_description": "The Deryn offers apartments near Brenau University with cable and internet included, plus community amenities in Gainesville, GA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "page_item_url": "gainesville-campus-student-center-apartments",
      "search_query": "Gainesville Campus Student Center nearby apartments",
      "category": "School",
      "h1_title": "Nearby Apartments to Gainesville Campus Center",
      "h2_subtitle": "The Deryn offers student-friendly apartments close to the Gainesville Campus Student Center. Enjoy convenient access to campus facilities.",
      "page_copy": "The Deryn offers apartments near University of North Georgia Gainesville Campus Student Center in Gainesville, GA. The community provides convenient access to campus facilities, local services, and surrounding destinations throughout Hall County.\nResidents have access to amenities including a fitness center with free weights, a swimming pool, and a poolside grilling area. Cable and internet service are included. The community is also located near shopping, dining, entertainment, and major roadways throughout Gainesville, providing access to everyday conveniences and local destinations.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with swimming pool and lounge chairs.",
        "public_id": "019d54f3-6513-704e-8300-7f52b8d04ec9",
        "storage_key": "property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Gainesville Campus Center",
      "seo_description": "Apartments in Gainesville, GA near University of North Georgia Gainesville Campus Student Center with amenities and included cable and internet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "page_item_url": "apartments-near-ngmc-gainesville-hall-county",
      "search_query": "apartments near Northeast Georgia Medical Center Gainesville in Hall County",
      "category": "Hospital",
      "h1_title": "Apartments Near Northeast Georgia Medical Center",
      "h2_subtitle": "The Deryn offers convenient living near Northeast Georgia Medical Center in Gainesville. Experience comfort and proximity in Hall County.",
      "page_copy": "The Deryn offers apartments near Northeast Georgia Medical Center Gainesville in Hall County. The community provides convenient access to major employers, local services, and surrounding destinations throughout the Gainesville area.\nResidents have access to amenities including a fitness center with free weights, a swimming pool, and a poolside grilling area. Cable and internet service are included. The community is also located near shopping, dining, and entertainment options throughout Gainesville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with swimming pool and lounge chairs.",
        "public_id": "019d54f3-6513-704e-8300-7f52b8d04ec9",
        "storage_key": "property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Northeast Georgia Medical Center",
      "seo_description": "The Deryn offers apartments near Northeast Georgia Medical Center Gainesville with cable and internet included, plus community amenities in Gainesville, GA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "page_item_url": "apartments-near-lanier-point-park-gainesville",
      "search_query": "apartments near Lanier Point Park Gainesville",
      "category": "Park",
      "h1_title": "Apartments Near Lanier Point Park, Gainesville",
      "h2_subtitle": "Discover The Deryn's prime location near Lanier Point Park in Gainesville. Enjoy outdoor activities and comfortable living.",
      "page_copy": "The Deryn offers apartments near Lanier Point Park in Gainesville, GA. The community provides convenient access to nearby parks, outdoor recreation areas, and local amenities.\nResidents have access to a fitness center with free weights, a swimming pool, and a poolside grilling area. Cable and internet service are included. The community is also located near shopping, dining, and major roadways throughout the Gainesville area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with swimming pool and lounge chairs.",
        "public_id": "019d54f3-6513-704e-8300-7f52b8d04ec9",
        "storage_key": "property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lanier Point Park, Gainesville",
      "seo_description": "Live at The Deryn, near Lanier Point Park in Gainesville. Perfect location for nature lovers seeking convenient and modern apartment living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "page_item_url": "apartments-close-to-alberta-banks-park-hall-county",
      "search_query": "apartments close to Alberta Banks Park Hall County",
      "category": "Park",
      "h1_title": "Apartments Close to Alberta Banks Park",
      "h2_subtitle": "Explore The Deryn, ideally located near Alberta Banks Park in Hall County. Enjoy easy access to local recreation areas.",
      "page_copy": "The Deryn offers apartments near Alberta Banks Park in Hall County. The community provides convenient access to nearby parks, recreational facilities, and local amenities.\nResidents have access to a fitness center with free weights, a swimming pool, and a poolside grilling area. Cable and internet service are included. The community is also located near shopping, dining, and major roadways throughout the Gainesville area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with swimming pool and lounge chairs.",
        "public_id": "019d54f3-6513-704e-8300-7f52b8d04ec9",
        "storage_key": "property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Alberta Banks Park",
      "seo_description": "Find your ideal home at The Deryn, close to Alberta Banks Park in Hall County. Enjoy great amenities and park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "page_item_url": "rentals-near-river-forks-park-30504",
      "search_query": "rentals near River Forks Park 30504",
      "category": "Park",
      "h1_title": "Rentals Near River Forks Park in 30504",
      "h2_subtitle": "Discover The Deryn's rentals conveniently located near River Forks Park. Enjoy Gainesville's scenic beauty right at your doorstep.",
      "page_copy": "Nestled in the vibrant 30504 area, The Deryn offers exceptional rentals near River Forks Park, perfect for those looking to enjoy Gainesville's outdoor charm. The park's natural beauty and recreational facilities are just a stone's throw away, providing endless opportunities for picnicking, hiking, and lakeside relaxation.\n\nOur community boasts spacious living with amenities designed for your comfort, including a fitness center with free weights, a sparkling swimming pool, and poolside grilling options. Cable and internet are included, ensuring you're always connected. Relish in the convenience and natural beauty of living at The Deryn.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with swimming pool and lounge chairs.",
        "public_id": "019d54f3-6513-704e-8300-7f52b8d04ec9",
        "storage_key": "property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near River Forks Park, Gainesville",
      "seo_description": "Experience The Deryn's rentals near River Forks Park in the 30504 area. Ideal for those seeking nature and convenience in Gainesville.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167334",
      "source": "custom",
      "page_item_url": "living-near-gainesville-square-ga",
      "search_query": "living near Gainesville Square GA",
      "category": "Park",
      "h1_title": "Living Near Gainesville Square, GA",
      "h2_subtitle": "Experience the vibrant lifestyle at The Deryn, located just moments from Gainesville Square. Enjoy shopping, dining, and entertainment nearby.",
      "page_copy": "The Deryn offers apartments near Gainesville Square in Gainesville, GA. The community provides convenient access to shopping, dining, entertainment, and local businesses throughout the downtown area.\nResidents have access to a fitness center with free weights, a swimming pool, and a poolside grilling area. Cable and internet service are included. The community is also located near major roadways and everyday conveniences throughout Gainesville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with swimming pool and lounge chairs.",
        "public_id": "019d54f3-6513-704e-8300-7f52b8d04ec9",
        "storage_key": "property/6767906449167334/019d54f3-6513-704e-8300-7f52b8d04ec9.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Gainesville Square, GA",
      "seo_description": "Discover The Deryn's premier location near Gainesville Square, GA. Enjoy local shopping and dining just steps from home.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "brianna@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6077"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11671056810"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PGBZBB9K"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "55472919606"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_call_rail_company_id",
      "type": "STRING",
      "value": "839622396"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_call_rail_account_hash",
      "type": "STRING",
      "value": "e5ceabedd2e750b87468"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlNxSFJzWFpRcUhRd0JZNVVSKzg4cEE9PSIsInZhbHVlIjoiU01GemZNZWZua1ViL1lwY3BpMGNQUT09IiwibWFjIjoiN2U0ZTYyY2JhMTAzOTAwNDNkMWRjN2YwYTVlMWJkMDJkMTQ0MzA0MzgyZTQ3NjQ0MTcyMTc3MmVkNTU1ODA4MCJ9"
    }
  ],
  "custom_csm": "brianna@repli360.com",
  "custom_qb_id": "6077",
  "custom_repli_id": "11671056810",
  "custom_google_gtm_id": "GTM-PGBZBB9K",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "55472919606",
  "custom_social_subscription": "none",
  "custom_call_rail_company_id": "839622396",
  "custom_website_subscription": "turnkey",
  "custom_call_rail_account_hash": "e5ceabedd2e750b87468",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlNxSFJzWFpRcUhRd0JZNVVSKzg4cEE9PSIsInZhbHVlIjoiU01GemZNZWZua1ViL1lwY3BpMGNQUT09IiwibWFjIjoiN2U0ZTYyY2JhMTAzOTAwNDNkMWRjN2YwYTVlMWJkMDJkMTQ0MzA0MzgyZTQ3NjQ0MTcyMTc3MmVkNTU1ODA4MCJ9",
  "custom_audioeye_site_id": "e8023b92-2ae1-4393-b354-1b93eb38dc3c",
  "custom_audioeye_site_hash": "2a63c36d1c36bcafc9c786d0970f557a"
};

export const generatedAt = '2026-10-12T19:38:12.657Z';
